export default {
  "custom": {
    linkedReference: 'مرتبط',
    boot: 'تشغيل',
    shutDown: 'إيقاف',
    notLinked: 'غير مرتبط',
    maxLinkedTip: 'يسمح بحد أقصى 2 ارتباطات {type}، تم الاستعادة تلقائياً إلى غير مرتبط',

    bar_Power: 'طاقة',
    bar_Video: 'تبديل الفيديو',
    bar_Vol: 'مستوى الصوت',
    bar_Audio: 'تبديل الصوت',
    bar_Serial: 'تسلسلي',
    bar_Air: 'مكيف الهواء',
    bar_Projection: 'شاشة العرض',
    bar_Remote: 'التحكم عن بُعد',
    bar_Matrix: 'IQShare Matrix',
    youMustSelectAllThreeImagesAtTheSameTime: 'يجب تحديد جميع الصور الثلاث في نفس الوقت',
    notSelected: 'غير محدد',
    choose: 'اختر',
    disable: 'تعطيل',
    "longPressAndDrag": "اضغط مطولاً واسحب لضبط ترتيب القائمة",
    "isrestoreDefault": "هل تريد الاستعادة إلى الحالة الافتراضية؟",
    "saveAndSync": "حفظ ومزامنة",
    "restoreDefault": "استعادة الافتراضي",
    "limitPNG": "يمكن تحميل صور PNG فقط!",
    "limit1M": "يجب ألا يتجاوز حجم الصورة 1 ميغابايت!",
    "selectTheImage": "اختر الصورة",
    "textsuggestions": "موصى به: أيقونة PNG بيضاء 48*48 بكسل أقل من 1 ميغابايت",
    "iconLibrary": "مكتبة الأيقونات",
    "panelNavigationBarCustomization": "شريط تنقل اللوحة",
    "logoCustomization": "شعار اللوحة"
  },
  outlook: {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    AuthVerify4004One: 'Binding failed: This Microsoft tenant (ID: ',
    AuthVerify4004Two: ") is already occupied by the organization [",
    AuthVerify4004Three: "].To rebind, please first unbind it from the original organization or use a different Microsoft tenant.",
    theMicrosoftTenantIsOccupied: 'The Microsoft tenant is occupied',
    Viewtutorial: 'عرض برنامج التعليمات للربط',
    checktenantID: 'يرجى التحقق من صحة معرف المستأجر، معرف التطبيق، ومفتاح التطبيق.',
    ErrorCode: 'رمز الخطأ:',
    AuthorizationFailed: 'فشل التخويل',
    Accesshasbeengranted: 'تم منح الوصول إلى واجهة برمجة تطبيقات Microsoft Graph بنجاح',
    successfullyauthorizedDescribe: 'تم تفويض الأذونات المطلوبة بنجاح. سيتم مزامنة بيانات غرفة الاجتماعات تلقائيًا. يرجى إغلاق هذه الصفحة.',
    Close: 'إغلاق',
    resourceID: 'معرف المورد',
    dialogTips: 'تلميحات',
    theAuthorizationIsDeleted: 'تم إزالة التخويل',
    theBindingIsSuccessful: 'الربط ناجح',
    theUnbindingIsSuccessful: 'إلغاء الربط ناجح',
    unbindingFailed: 'فشل إلغاء الربط',
    theUnbindingHasBeenUnbound: 'تم إلغاء إلغاء الربط',
    continueUnbinding: 'سيتوقف مزامنة Outlook وسيتم مسح جميع الأحداث القادمة. متابعة إلغاء الربط؟',
    areYouSureAboutUnbinding: 'سيتم مسح جميع أحداث Outlook القادمة وسيتوقف المزامنة. لا يمكن التراجع عن هذا الإجراء. تأكيد إلغاء الربط؟',
    UnbindNotSynchronized: 'بعد الربط، سيتم مزامنة أحداث Outlook الجديدة لهذه الغرفة تلقائيًا (لن يتم مزامنة الأحداث السابقة)',
    unbinding: 'إلغاء الربط',
    bindUnableToSelect: 'تم ربطه بالفعل، لا يمكن التحديد',
    permissAThird: 'يرجى التخويل لربط موارد الطرف الثالث',
    resourceMailbox: 'بريد المورد:',
    PleasecheckID: 'فشل التخويل! يرجى التحقق من صحة معرف المستأجر، معرف التطبيق، وسر العميل.',
    Waitingforauthorization: 'في انتظار التخويل...',
    Pleasecompletetheauthorization: 'تم فتح صفحة تسجيل الدخول إلى Microsoft 365. يرجى تسجيل الدخول باستخدام حساب مسؤول لإكمال التخويل.',
    pleaseEnterTheTenantID: 'يرجى إدخال معرف المستأجر',
    pleaseEnterTheClientID: 'يرجى إدخال معرف التطبيق',
    pleaseEnterTheClientSecret: 'يرجى إدخال سر العميل',
    Authorizationcompleted: 'تم إكمال التخويل',
    Authorizelogin: 'تخويل تسجيل الدخول إلى Microsoft 365',
    ApplicationID: 'معرف المستأجر',
    ClientID: 'معرف التطبيق',
    ClientSecret: 'سر العميل',
    registTipOne: 'يرجى اتباع',
    registTipTwo: 'دليل الربط',
    registTipThree: 'إكمال تسجيل تطبيق Azure وإعدادات الأذونات قبل ملء الحقول أدناه.',
    MicrosoftDescribe: 'من خلال ربط Microsoft 365، يمكن مزامنة الاجتماعات المحجوزة في Outlook/Teams تلقائيًا إلى وحدة تحكم Q-NEX وجدولة الغرف.',
    Addcalendarservice: 'إعدادات مزامنة التقويم',
    Lasttimesynchronization: 'آخر وقت مزامنة',
    Allocated: 'مخصص',
    Total: 'الإجمالي',
    Conferenceroomresources: 'موارد غرفة الاجتماعات',
    Bindingtime: 'وقت الربط',
    Bindtheplatform: 'منصة الربط',
    Synchronousstate: 'حالة المزامنة',
    Organizationname: 'اسم المؤسسة',
    Bindthirdpartycalendar: 'ربط تقويم طرف ثالث',
    TenantIDTip: 'معرف فريد في Azure AD',
    ApplicationIDTip: 'معرف التطبيق المسجل في Azure',
    ApplicationSecretTip: 'سر العميل المُنشأ في Azure للمصادقة'
  },
  "meetingManager": {
    IdleDisplayTextTable: 'نص العرض عند الخمول',
    IdleDisplayText: 'نص العرض عند الخمول:',
    IdleDisplayTextContent: 'النص المعروض عندما تكون الغرفة فارغة (الافتراضي: "فارغ")',

    duplicateMeetingRoomName: 'اسم غرفة الاجتماع مكرر',
    duplicateMeetingRoomNameContent: 'توجد بالفعل غرفة اجتماع باسم "{duplicate_content}". يرجى إدخال اسم آخر.',
    NumberOfRoomPanels: 'عدد لوحات الغرفة',
    "Thecurrentterminalhasbeenboundtoanotherorganization": "تم ربط الطرفية الحالية بالفعل بمنظمة أخرى.",
    "theTerminalNameOrIDIsDuplicated": "اسم أو معرف اللوحة هو نفسه",
    theRoomNameOrIDIsDuplicated: 'اسم غرفة الاجتماع أو الموقع مكرر.',
    "AddMeetingRoom": "إضافة غرفة اجتماعات",
    "EditMeetingRoom": "تعديل غرفة اجتماعات",
    "MeetingRoomName": "اسم غرفة الاجتماعات:",
    "Location": "الموقع:",
    "ReservationApproval": "موافقة الحجز:",
    "ApprovalListYes": "نعم",
    "ApprovalListNo": "لا",
    "Capacity": "السعة:",
    "RoomStatus": "حالة الغرفة:",
    "BindRoomDisplay": "ربط لوحة الغرفة:",
    "meeting_btnAdd": "إضافة",
    "meeting_btnEdit": "تعديل",
    "meeting_btnBind": "ربط الجهاز",
    "meeting_btnDel": "حذف",
    "meeting_tableRoomName": "اسم غرفة الاجتماعات",
    "meeting_tableRoomPlace": "الموقع",
    "meeting_tableAppointmentApproval": "موافقة الحجز",
    "meeting_tableCapacityForPeople": "السعة",
    "meeting_tableMeetingRoomStatus": "حالة الغرفة",
    "meeting_tableAvaliable": "متاحة",
    "meeting_tableOutofService": "خارج الخدمة",
    "meeting_tableDoorBind": "ربط الباب",
    "meeting_tableBindNPS": "ربط NPS",
    "meeting_tableActions": "الإجراءات",
    "door_theNameOfTheTerminal": "اسم اللوحة:",
    "door_deviceID": "معرف اللوحة:",
    "door_Wallpaper": "خلفية الشاشة:",
    "door_Wallpaper_text": "الصورة الموصى بها: الحجم 1280x800، بصيغة PNG",
    "door_bindAMeetingRoom": "ربط غرفة الاجتماعات:",
    "door_table_name": "اسم اللوحة",
    "door_table_deviceID": "معرف اللوحة",
    "door_table_status": "الحالة",
    "door_table_ipAddress": "عنوان IP",
    "door_table_bindAMeetingRoom": "ربط غرفة الاجتماعات",
    "door_btnAdd": "إضافة",
    "door_btnBatchAdd": "إضافة دفعة",
    "door_btnEdit": "تعديل",
    "door_btnBatchEdit": "تعديل دفعة"
  },
  "InputSourcesLinkage": {
    "configurationAddTitle": "إضافة تكوين",
    "configurationEditTitle": "تحرير التكوين",
    "dialogConfigName": "اسم التكوين",
    "selectNMPAndNDP": "الأجهزة المستهدفة",
    "powerControl": "التحكم في الطاقة",
    "executeCommand": "افعل",
    "tableConfigName": "اسم التكوين",
    "selectConfig": "يرجى اختيار التكوين"
  },
  "NPS": {
    "Relay": "الريلاي",
    "RelaySettings": "إعدادات الريلاي",
    "DevicePower": "التحكم في طاقة الجهاز",
    "DeviceElevation": "التحكم في الرفع",
    "LinageWithNPSPower": "الربط مع طاقة NPS",
    "PresentationSwitch": "مفتاح العرض",
    "Duplicate": "مضاعف",
    "LinkagewithNPSPowe": "الربط مع طاقة NPS"
  },
  "PTZ": {
    "powerSupplyON": "تشغيل",
    "powerSupplyOFF": "إيقاف",
    "LEFT": "يسار",
    "RIGHT": "يمين",
    "UP": "أعلى",
    "DOWN": "أسفل",
    "HOME": "الصفحة الرئيسية",
    "ENLARGE": "تكبير",
    "REDUCTION": "تصغير",
    "StopMovement": "إيقاف الحركة",
    "STOP": "إيقاف التكبير",
    "FOCUS": "التركيز",
    "SET_PRESETS0": "تحديد_الإعداد0",
    "SET_PRESETS1": "تحديد_الإعداد1",
    "SET_PRESETS2": "تحديد_الإعداد2",
    "SET_PRESETS3": "تحديد_الإعداد3",
    "SET_PRESETS4": "تحديد_الإعداد4",
    "SET_PRESETS5": "تحديد_الإعداد5",
    "SET_PRESETS6": "تحديد_الإعداد6",
    "SET_PRESETS7": "تحديد_الإعداد7",
    "SET_PRESETS8": "تحديد_الإعداد8",
    "SET_PRESETS9": "تحديد_الإعداد9",
    "USE_PRESETS0": "استخدام_الإعداد0",
    "USE_PRESETS1": "استخدام_الإعداد1",
    "USE_PRESETS2": "استخدام_الإعداد2",
    "USE_PRESETS3": "استخدام_الإعداد3",
    "USE_PRESETS4": "استخدام_الإعداد4",
    "USE_PRESETS5": "استخدام_الإعداد5",
    "USE_PRESETS6": "استخدام_الإعداد6",
    "USE_PRESETS7": "استخدام_الإعداد7",
    "USE_PRESETS8": "استخدام_الإعداد8",
    "USE_PRESETS9": "استخدام_الإعداد9"
  },
  "schedule": {
    "startLinkPowerStart": "تشغيل (ريليه CBXs)  ",
    "startLinkPowerStop": "إيقاف (ريليه CBXs)  ",
    "dehumidification": "جاف  ",
    "airSupply": "مروحة  ",
    "masterControl": "الرئيسي:  ",
    "powerSupply": "الطاقة  ",
    "lockScreen": "قفل  ",
    "RecordingControl": "تحكم التسجيل  ",
    "RecordingControlSystem": "نظام تسجيل المحاضرات  ",
    "LiquidCrystal": "لوحة تفاعلية بشاشة مسطحة  ",
    "projector": "جهاز عرض  ",
    "othertype": "آخر  ",
    "childLock": "قفل الطفل  ",
    "energySaving": "توفير الطاقة  ",
    "signalSourceSwitching": "مصدر الإدخال  ",
    "other": "الميزات الأخرى:  ",
    "otherFunction": "الوظيفة  ",
    "send": "إرسال  ",
    "ON": "تشغيل  ",
    "OFF": "إيقاف  ",
    "btnAddSchedule": "استعادة  ",
    "EditSchedulelist": "تعديل الجدول الزمني  ",
    "AddSchedulelist": "إضافة جدول زمني  ",
    "RestoreSchedulelist": "استعادة  ",
    "btn": "إلغاء  ",
    "btnNewList": "جدول زمني جديد  ",
    "ListName": "الاسم  ",
    "Cannotquit": "إجباري  ",
    "NOCannotquit": "لا  ",
    "ListValidityPeriod": "فترة الصلاحية  ",
    "ListDescription": "الوصف  ",
    "currentSchedule": "قائمة الجداول الزمنية  ",
    "historySchedule": "قائمة السجل  ",
    "selectTime": "الوقت  ",
    "taskType": "نوع المهمة  ",
    "selectBroadcasting": "البث  ",
    "selectDeviveControl": "التحكم في الجهاز  ",
    "newSchedule": "مهمة جديدة  ",
    "newChecklist": "قائمة فحص جديدة  ",
    "titleStatus": "الحالة  ",
    "titleType": "النوع  ",
    "titleStartTime": "وقت البدء  ",
    "titleEndTime": "وقت الانتهاء  ",
    "titleRepeat": "التكرار  ",
    "titleName": "الاسم  ",
    "titleAction": "الإجراء  ",
    "tableEnabled": "مفعل  ",
    "tablePaused": "موقوف  ",
    "tableEdit": "تعديل  ",
    "tableDelete": "حذف",
    "tableVolumeEdit": "حجم البث  ",
    "tableBroadcastTitle": "العنوان  ",
    "tableBroadcastContent": "المحتوى  ",
    "tableBroadcastList": "القائمة  ",
    "tableBroadcast": "إجباري  ",
    "btnRemoveCompletely": "إزالة بالكامل  ",
    "btnEnabled": "مفعل  ",
    "btnPaused": "معلق  ",
    "btnDelete": "حذف  ",
    "repeat0": "الاثنين  ",
    "repeat1": "الثلاثاء  ",
    "repeat2": "الأربعاء  ",
    "repeat3": "الخميس  ",
    "repeat4": "الجمعة  ",
    "repeat5": "السبت  ",
    "repeat6": "الأحد  ",
    "dialogTitleAdd": "مهمة جديدة للتحكم في الجهاز  ",
    "dialogTitleEdit": "تحرير مهمة التحكم في الجهاز  ",
    "newBroadcastingSchedule": "مهمة جديدة للبث  ",
    "editBroadcastingSchedule": "تحرير مهمة البث  ",
    "chooseDevice": "اختيار الجهاز  ",
    "timeSetting": "إعداد الوقت  ",
    "controlBroadcasting": "خيارات البث  ",
    "controlOption": "خيارات التحكم  ",
    "scheduleName": "اسم المهمة:  ",
    "destination": "الوجهة  ",
    "timeTilte": "الوقت  ",
    "repeatTitle": "التكرار  ",
    "dialogRepeat0": "الاثنين  ",
    "dialogRepeat1": "الثلاثاء  ",
    "dialogRepeat2": "الأربعاء  ",
    "dialogRepeat3": "الخميس  ",
    "dialogRepeat4": "الجمعة  ",
    "dialogRepeat5": "السبت  ",
    "dialogRepeat6": "الأحد  ",
    "dialogOnceType": "مرة واحدة  ",
    "dialogRepeatType": "تكرار  ",
    "mainPower": "الطاقة الرئيسية  ",
    "powerControl": "تحكم الطاقة  ",
    "tableDisplayInputSwitch": "مفتاح إدخال العرض  ",
    "tableAirConditioning": "المكيف  ",
    "tableProjectionScreen": "شاشة العرض  ",
    "tableElectronicLock": "القفل الكهربائي  ",
    "interactiveFlatPanel": "لوحة تفاعلية بشاشة مسطحة  ",
    "displayInputSwitch": "مفتاح إدخال العرض  ",
    "speakerVolume": "مستوى الصوت للسماعات  ",
    "MICVolume": "مستوى الصوت للميكروفون  ",
    "ProjectionScreen": "شاشة العرض  ",
    "ElectronicLock": "القفل الكهربائي  ",
    "AirConditioning": "المكيف",
    "AirConditioningPower": "الطاقة  ",
    "AirConditioningModel": "النموذج  ",
    "AirConditioningTEMP": "TEMP  ",
    "AirConditioningFanSpeed": "سرعة المروحة  ",
    "OPEN": "فتح  ",
    "CLOSE": "إغلاق  ",
    "UP": "أعلى  ",
    "DOWN": "أسفل  ",
    "PowerOFF": "إيقاف  ",
    "PowerON": "تشغيل  ",
    "ModelAuto": "تلقائي  ",
    "ModelCool": "تبريد  ",
    "ModelHeat": "تسخين  ",
    "ModelAir": "جانب الهواء  ",
    "TEMPLow": "منخفض  ",
    "TEMPMiddle": "متوسط  ",
    "TEMPHigh": "عالي  ",
    "btnSave": "حفظ  ",
    "btnNext": "التالي  ",
    "StartTime": "وقت البدء  ",
    "StopTime": "وقت التوقف  ",
    "Mandatory": "إلزامي  ",
    "Video": "فيديو وصوت  ",
    "Notification": "إشعار  ",
    "btnFile": "اختيار ملف وسائط  ",
    "LastingTime": "المدة  ",
    "textTitle": "العنوان  ",
    "textContent": "المحتوى  ",
    "textTitleLetters": "أقل من 60 حرفًا  ",
    "textContentLetters": "أقل من 320 حرفًا  ",
    "CannotquitYES": "نعم  ",
    "CannotquitNo": "لا  ",
    "YES": "نعم  ",
    "No": "لا  ",
    "delTitleContent": "هل أنت متأكد أنك تريد حذف هذا المجدول؟  ",
    "delTitleListContent": "سيتم نقل المجدول المحذوف إلى قائمة التاريخ ويمكن استعادته  ",
    "deleListTitle": "هل تريد حذف المجدول؟  ",
    "delTitleListContent1": "حذف المجدول سيؤدي إلى مسح المهام المرتبطة به، يرجى التأكيد.  ",
    "deleListTitle1": "هل أنت متأكد أنك تريد حذف هذا المجدول؟  ",
    "delTitle": "حذف؟  ",
    "btnConfirm": "تأكيد  ",
    "coxAll": "الكل  ",
    "coxBroadcasting": "البث  ",
    "coxDeviveControl": "التحكم في الجهاز  ",
    "rdMandatory": "نعم  ",
    "noRdMandatory": "لا  ",
    "startDate": "تاريخ البدء  ",
    "endedDate": "تاريخ الانتهاء  ",
    "or": "-  ",
    "broadcastingType": "النوع",
    "ChooseTime": "اختر الوقت  ",
    "ChooseDate": "اختر التاريخ  ",
    "newScheduleList": "مجدول جديد  ",
    "editScheduleList": "تعديل المجدول  ",
    "listName": "الاسم  ",
    "listValidityPeriod": "فترة الصلاحية  ",
    "listDescription": "الوصف  ",
    "cancel": "إلغاء  ",
    "confirm": "تأكيد  ",
    "save": "حفظ  ",
    "addSuccess": "تم الإضافة بنجاح!  ",
    "addError": "فشل في الإضافة!  ",
    "editSuccess": "تم التعديل بنجاح!  ",
    "editError": "فشل في التعديل!  ",
    "delSuccess": "تم الحذف بنجاح!  ",
    "delError": "فشل في الحذف!  ",
    "restoreSuccess": "تم استعادة قائمة الجداول بنجاح  ",
    "restoreError": "فشل في استعادة قائمة الجداول  ",
    "restoreTitleContent": "هذا الوقت يتعارض مع الوقت في القائمة، يرجى الاختيار مرة أخرى  ",
    "Enabled": "مفعل  ",
    "Paused": "مؤقت  ",
    "Title": "العنوان:  ",
    "Content": "المحتوى:  ",
    "errorScheduleNameRequired": "يجب ملء اسم المهمة  ",
    "errorDeviceRequired": "يرجى اختيار الجهاز المستهدف  ",
    "deleTitle": "هل أنت متأكد أنك تريد حذف هذه المهمة؟  ",
    "loopList": "قائمة التكرار  ",
    "errorPleaseDateRange": "يرجى اختيار نطاق تاريخي  ",
    "addError_2009": "اسم الجدول مكرر  ",
    "conflicts": "وقت المهمة يتعارض مع التالي:  ",
    "Pleaseagain": "يرجى إدخال مرة أخرى  ",
    "errorScheduleName": "اسم المهمة  ",
    "errorListName": "اسم الجدول  ",
    "today": "اليوم  ",
    "yesterday": "أمس  ",
    "thisWeek": "هذا الأسبوع  ",
    "lastWeek": "الأسبوع الماضي  ",
    "lastMonth": "الشهر الماضي  ",
    "thisMonth": "هذا الشهر  ",
    "times": "مرات  ",
    "TimeConflicts": "تعارض الوقت  ",
    "editError_2006": "الجهاز غير موجود  ",
    "editError_2010": "اسم المهمة مكرر  ",
    "ListTimeExpired": "انتهت صلاحية الجدول الزمني، يرجى الاختيار مرة أخرى  ",
    "TimeExpired": "انتهت صلاحية الوقت  ",
    "ControlOption": "تفتقد خيار التحكم  ",
    "Pleaseleastone": "يرجى اختيار خيار تحكم واحد على الأقل  ",
    "Enter": "إدخال  ",
    "TitleFilled": "يجب ملء العنوان  ",
    "ContentFilled": "يجب ملء المحتوى  ",
    "PleaseMediaFile": "يرجى اختيار ملف وسائط  ",
    "PleaseSchedule": "يرجى اختيار مهمة  ",
    "delTitleScheduleContent": "لا يمكن استرداد المهمة المحذوفة.  ",
    "deleTitleSchedule": "هل أنت متأكد أنك تريد حذف هذه المهمة؟  ",
    "deleteScheduleTitle": "يرجى اختيار المهمة للحذف  ",
    "PleaseFillColumn": "يرجى ملء اسم البرنامج  ",
    "PleaseDate": "يرجى اختيار التاريخ  ",
    "Previous": "السابق  ",
    "RemoteControl": "التحكم عن بعد  ",
    "taskhasexpired": "انتهت صلاحية هذه المهمة، يرجى الاتصال بالمنشئ لتحديث الوقت.  ",
    "execute": "تنفيذ  ",
    "broadcastingList": "قائمة البث  ",
    "volumeSuccess": "تم تعيين الصوت بنجاح  ",
    "volumeFailed": "فشل في تعيين الصوت  "
  },
  "Automation": {
    "nameDuplicate": "اسم المهمة مكرر تلقائيًا  ",
    "Automation": "أتمتة  ",
    "if": "إذا:  ",
    "ifContent": "يسمح لك قسم \"إذا\" بتحديد الشروط استنادًا إلى بيانات المستشعرات. اختر المستشعر وحدد الشروط مثل 'الحرارة > 26 درجة مئوية'.  ",
    "then": "ثم:  ",
    "thenContent": "يسمح لك قسم \"ثم\" باختيار الأجهزة وتحديد الإجراءات لها. اختر الأجهزة مثل NMP1، NMP2 وحدد الإجراءات مثل 'تشغيل + تبريد' لأجهزة التكييف.  ",
    "btnDelete": "حذف  ",
    "Add": "إضافة  ",
    "taskName": "اسم المهمة  ",
    "dialogTaskName": "اسم المهمة:  ",
    "Statue": "الحالة  ",
    "DevicesApplied": "الأجهزة المطبقة  ",
    "Operation": "العملية  ",
    "AirConditioningPower": "الطاقة  ",
    "AirConditioningModel": "النموذج  ",
    "AirConditioningFanSpeed": "سرعة المروحة  ",
    "bold": "التأرجح  ",
    "selectTask": "يرجى اختيار المهمة  ",
    "autoTaskAdd": "إضافة مهمة أتمتة  ",
    "autoTaskEdit": "تحرير مهمة أتمتة  ",
    "Destination": "الوجهة  ",
    "selectConditions": "يرجى تحديد الإجراء الذي تريد تنفيذه.  ",
    "selectDestination": "يرجى اختيار الجهاز (الأجهزة) الهدف (الأهداف) NMP، ثم تحديد الإجراء الذي تريد تنفيذه  ",
    "AirConditioningTEMP": "درجة الحرارة  ",
    "AirConditioningHumidness": "الرطوبة  ",
    "noData": "لم تتم إضافة أي مهام بعد. انقر على \"إضافة\" لإضافة المهام.  "
  },
  "rs232Translation": {
    "reliveBinding": "فصل  ",
    "RELIVEBINDING": "فصل",
    "ACTO": "ACTO",
    "AMENA": "AMENA",
    "APPOTRONICS": "APPOTRONICS",
    "APTI": "APTI",
    "ASEE": "ASEE",
    "ASK": "ASK",
    "AUCMA": "AUCMA",
    "AUX": "AUX",
    "BARCO": "BARCO",
    "BENQ": "BENQ",
    "BOERKA": "BOERKA",
    "BOXLIGHT": "BOXLIGHT",
    "Canon": "Canon",
    "CARRIER": "CARRIER",
    "CHANGHONG": "CHANGHONG",
    "CHIGO": "CHIGO",
    "CHRISTIE": "CHRISTIE",
    "Chunlan": "Chunlan",
    "COSTAR": "COSTAR",
    "CROWN": "CROWN",
    "CX": "CX",
    "DAEWOO": "DAEWOO",
    "DAIKIN": "DAIKIN",
    "DIGITEL": "DIGITEL",
    "DONGBAO": "DONGBAO",
    "EIKI": "EIKI",
    "electra": "electra",
    "Electrolux": "Electrolux",
    "EPSON": "EPSON",
    "FEILU": "FEILU",
    "FOUNDER": "FOUNDER",
    "Frestec": "Frestec",
    "Fujitsu": "Fujitsu",
    "Galanz": "Galanz",
    "GREE": "GREE",
    "Haier": "Haier",
    "Hisense": "Hisense",
    "HITACHI": "HITACHI",
    "HP": "HP",
    "HUIFENG": "HUIFENG",
    "InFocus": "InFocus",
    "IQ": "IQ",
    "JVC": "JVC",
    "KODAK": "KODAK",
    "LANGER": "LANGER",
    "LENOVO": "LENOVO",
    "LG": "LG",
    "LITTLESWAN": "LITTLESWAN",
    "LUMENS": "LUMENS",
    "McQuay": "McQuay",
    "Microtek": "Microtek",
    "Mitsubishi": "Mitsubishi",
    "NANFENG": "NANFENG",
    "NEC": "NEC",
    "OPTOMA": "OPTOMA",
    "PALOROID": "PALOROID",
    "panisonic": "panisonic",
    "PHILIP": "PHILIP",
    "PJD": "PJD",
    "PLUS": "PLUS",
    "POLAROID": "POLAROID",
    "PROPIX": "PROPIX",
    "PROXIMA": "PROXIMA",
    "RAYBO": "RAYBO",
    "ROWA": "ROWA",
    "Samsung": "Samsung",
    "SANYO": "SANYO",
    "SAST": "SAST",
    "SEEMILE": "SEEMILE",
    "SHARP": "SHARP",
    "shengfeng": "shengfeng",
    "Shinco": "Shinco",
    "shuanglu": "shuanglu",
    "Sony": "Sony",
    "SOVA": "SOVA"
  },
  "VcbEdit": {
    "VcbNameNoNull": "اسم CBX لا يمكن أن يكون فارغاً  ",
    "BrandNoNull": "العلامة التجارية لا يمكن أن تكون فارغة  ",
    "ModelNoNull": "النموذج لا يمكن أن يكون فارغاً  ",
    "AcNoNull": "التحكم في التكييف لا يمكن أن يكون فارغاً  ",
    "RcNoNull": "التحكم عن بُعد لا يمكن أن يكون فارغاً"
  },
  "route": {
    customize: 'تخصيص',
    "InputSourcesLinkage": "رابط مصادر الإدخال  ",
    "Automation": "أتمتة  ",
    "dashboard": "Dashboard",
    "i18n": "I18n  ",
    "organizationMge": "المجموعات  ",
    "userMge": "المستخدمون  ",
    "authorityMge": "الإذن  ",
    "roleMge": "الأدوار  ",
    "equipmentMge": "الأجهزة  ",
    "workstationMge": "خادم الوسائط  ",
    "cloudDiskMge": "إدارة التخزين  ",
    "operationLog": "سجل العمليات  ",
    "setting": "الإعدادات  ",
    "resourceMge": "إدارة الموارد  ",
    "storageMge": "إدارة التخزين  ",
    "interfaceRename": "إعادة تسمية الواجهة  ",
    "processorManager": "إدارة المعالج  ",
    "projectorCode": "إدارة الرموز التسلسلية  ",
    "projectorCodeSetting": "إعدادات الرموز التسلسلية  ",
    "RepairLog": "سجل الإصلاح  ",
    "remoteControl": "رمز التحكم عن بُعد  ",
    "acCode": "رمز التحكم في التكييف  ",
    "cardMge": "البطاقات  ",
    "cardLog": "سجل استخدام البطاقات  ",
    "cardManager": "إدارة البطاقات  ",
    "meetingManager": "الاجتماع  ",
    "meetingRoomManager": "إدارة الغرف  ",
    "meetingDoorManager": "إدارة اللوحات"
  },
  "navbar": {
    "logOut": "تسجيل الخروج  ",
    "dashboard": "لوحة القيادة  ",
    "screenfull": "الشاشة الكاملة  ",
    "language": "اللغة  ",
    "userConsole": "وحدة تحكم Q-NEX  ",
    "BackTianwa": "العودة إلى Tianwa"
  },
  "feedback": {
    "Feedback": "التعليقات  ",
    "email": "يرجى ترك بريدك الإلكتروني لتلقي تعليقاتنا.  ",
    "content": "مرحبًا وترك رسائل لتحسين منتجاتنا. شكرًا لتعليقاتك.  ",
    "submit": "إرسال  ",
    "emailNoEmpty": "البريد الإلكتروني لا يمكن أن يكون فارغاً  ",
    "emailTrueRule": "يرجى إدخال البريد الإلكتروني بشكل صحيح  ",
    "contentNoEmpty": "المحتوى لا يمكن أن يكون فارغاً  ",
    "feedbackSuccess": "نجاح التعليق  ",
    "feedbackFailed": "فشل التعليق  ",
    "emailNoChinese": "صندوق البريد لا يمكن أن يحتوي على حروف صينية  ",
    "emailLength": "من 5 إلى 100 حرف  ",
    "GroupNameLength": "من 1 إلى 20 حرف  ",
    "emailSpecialString": "لا يمكن أن يحتوي هذا مربع الإدخال على سلاسل خاصة"
  },
  "login": {
    "title": "مرحبًا  ",
    "logIn": "تسجيل الدخول  ",
    "username": "اسم المستخدم  ",
    "password": "كلمة المرور  ",
    "any": "أي  ",
    "thirdparty": "أو الاتصال بـ  ",
    "thirdpartyTips": "لا يمكن محاكاة ذلك محليًا، لذا يرجى دمج محاكاة أعمالك الخاصة!  ",
    "placeholder": "[  \n  \"اسم المستخدم\",  \n  \"كلمة المرور\",  \n  \"رمز التحقق\"  \n]  ",
    "userNameTitle": "اسم المستخدم غير صحيح!  ",
    "forget": "هل نسيته؟  ",
    "loginTitle0": "تم تسجيل الدخول بنجاح!  ",
    "loginTitle1000": "اسم المستخدم أو كلمة المرور غير صحيحة!  ",
    "loginTitle1001": "يجب ملء اسم المستخدم وكلمة المرور!  ",
    "loginTitle1002": "يجب ملء رمز التحقق!  ",
    "loginTitle1003": "حالة المستخدم غير قانونية، فشل في تسجيل الدخول!  ",
    "loginTitle1004": "خطأ في رمز التحقق!  ",
    "loginTitle1005": "لم يتم تسجيل الدخول، يرجى تسجيل الدخول أولاً!  ",
    "loginTitleUserName": "يجب ملء اسم المستخدم!  ",
    "loginTitlePwd": "يجب ملء كلمة المرور!  ",
    "loginTitleVercode": "يجب ملء رمز التحقق!  ",
    "errorLogin": "حقوق المستخدم غير كافية، لا يمكن تسجيل الدخول!  ",
    "titleLoginNameFormat": "يجب أن يتكون من أحرف أو أحرف وأرقام."
  },
  "organizationMge": {
    "CanTDragTop": "لا يمكن الانتقال إلى الجذر  ",
    "prefixCannotBeEmpty": "لا يمكن أن يكون بادئة حساب المسؤول الأعلى فارغًا  ",
    "enterEnglishLetters": "يمكن أن يحتوي بادئة حساب المسؤول الأعلى على أحرف إنجليزية وأرقام فقط  ",
    "dateNotSelected": "لم يتم تحديد تاريخ بدء فترة صلاحية خدمة البث  ",
    "btnAddChild": "إضافة مرؤوس  ",
    "btnAddSibling": "إضافة شقيق  ",
    "title": "نصيحة:  ",
    "againTitle": "يرجى التأكد مرة أخرى:  ",
    "sort": "ترتيب:  ",
    "realName": "الاسم الحقيقي:  ",
    "titleShooleRq": "يجب ملء هذا الحقل  ",
    "titleShooleNub": "أقل من 100 حرف  ",
    "schoolName": "اسم المجموعة:  ",
    "type": "نوع المجموعة:  ",
    "accountPrefix": "حساب المسؤول:  ",
    "organization": "الموزع  ",
    "terminalMechanism": "المستخدم النهائي  ",
    "equipmentNum": "رقم الجهاز:  ",
    "organizationNum": "عدد مجموعات الطرفيات:  ",
    "adminName": "حساب المسؤول:  ",
    "adminPwd": "كلمة مرور المسؤول:  ",
    "edit": "تعديل  ",
    "add": "إضافة  ",
    "del": "حذف  ",
    "addSuccess": "تم الإضافة بنجاح  ",
    "addError": "فشل الإضافة!  ",
    "editSuccess": "تم التعديل بنجاح  ",
    "editError": "فشل التعديل!  ",
    "delSuccess": "تم الحذف بنجاح!  ",
    "delWarn": "لا يمكن حذف هذه المجموعة مع الأجهزة المرتبطة  ",
    "delError": "فشل الحذف!  ",
    "cancel": "إلغاء  ",
    "confirm": "تأكيد  ",
    "save": "حفظ  ",
    "TrialWorkstation": "أنت في حالة تجريبية حاليًا، ويمكنك فقط بث وعرض مباشر على 3 أجهزة طرفية كحد أقصى.  ",
    "Normal": "عادي  ",
    "NormalWorkstation": "فترة صلاحية خدمة البث الخاصة بك هي من  ",
    "to": "إلى  ",
    "Advent": "المجيء  ",
    "AdventWorkstationOne": "ستنتهي خدمة البث الخاصة بك في",
    "AdventWorkstationTwo": ", يرجى الاتصال بوكيلك لتجديد الخدمة في الوقت المحدد للاستخدام العادي.  ",
    "Expired": "منتهي  ",
    "ExpiredWorkstation": "لقد انتهت خدمة البث الخاصة بك، يرجى الاتصال بوكيلك لتجديدها في الوقت المحدد.  ",
    "admin": "المسؤول:  ",
    "serviceState": "خدمة وسائط البث:  ",
    "serviceStateLIST": "خدمة وسائط البث  ",
    "ValidityPeriod": "فترة الصلاحية:  ",
    "ValidityPeriodLIST": "فترة الصلاحية  ",
    "Trial": "تجريبي  ",
    "Permanent": "دائم  ",
    "AnnualBilling": "الفوترة السنوية  ",
    "mediaValidityPeriod": "فترة الصلاحية:  ",
    "mediaValidityPeriodLIST": "فترة الصلاحية  ",
    "contactInformation": "بيانات الاتصال (لتذكير بتجديد خدمة البث)  ",
    "company": "اسم الشركة:  ",
    "email": "البريد الإلكتروني:  ",
    "phone": "الهاتف:  ",
    "StartDate": "تاريخ البدء  ",
    "EndDate": "تاريخ الانتهاء  ",
    "To": "إلى  ",
    "TerminalName": "اسم المستخدم النهائي  ",
    "Competence": "المسؤول  ",
    "operate": "تشغيل  ",
    "statusFilter": "مرشح الحالة  ",
    "disableStreaming": "هل أنت متأكد أنك تريد تعطيل خدمة البث؟  ",
    "enableStreaming": "هل أنت متأكد أنك تريد تفعيل خدمة البث؟  ",
    "disableStreamingContent": "عند تعطيل خدمة البث، لن يتمكن المجموعة من استخدام الوظائف المتعلقة بالبث والبث المباشر.  ",
    "enableStreamingContent": "يرجى تعديل فترة الصلاحية للمجموعات التي انتهت صلاحية خدمة البث الخاصة بها.  ",
    "search": "أدخل اسم المؤسسة  ",
    "optionsYearZero": "يرجى الاختيار",
    "optionsYearOne": "عام واحد  ",
    "optionsYearTwo": "سنتين  ",
    "optionsYearThree": "ثلاث سنوات  ",
    "dialogName": "الاسم:  ",
    "detTitle": "حذف المجموعة سيؤدي إلى حذف جميع المحتويات المرتبطة بها.  ",
    "groupDelTitle": "هل أنت متأكد أنك تريد حذف هذه المجموعة؟  ",
    "delTitle": "حذف؟  ",
    "delTitleContent": "سيتم حذف المحتويات المحددة من قاعدة البيانات. لا يمكن التراجع عن هذه العملية. هل أنت متأكد أنك تريد المتابعة؟  ",
    "delCancelButton": "إلغاء  ",
    "delConfirmButton": "تأكيد  ",
    "copySuccess": "تم نسخ المحتوى إلى الحافظة.  ",
    "copyError": "المتصفح لا يدعم النسخ التلقائي  ",
    "error1200": "اسم المجموعة مكرر  ",
    "error1201": "تكرار المجموعة أو معرف المجموعة  ",
    "error1202": "تجاوز العدد الأقصى للأجهزة المتصلة  ",
    "error1203": "اسم المستخدم مكرر  ",
    "error1204": "هناك مجموعة بنفس الاسم على نفس المستوى  ",
    "error1210": "يرجى إدخال كلمة مرور المسؤول  ",
    "warningGroup": "اختر مجموعة!  ",
    "warningTerminal": "لا يمكن للمجموعة الطرفية إنشاء مجموعات فرعية!  ",
    "account": "حساب مكرر  ",
    "titleOrganization": "ملاحظة: يتم تحديد بادئة الحساب على مستوى المؤسسة. جميع حسابات المستخدمين ضمن هذه المؤسسة ستشارك نفس البادئة.",
    "all": "الكل"
  },
  "userMge": {
    "nickName": "اسم مستعار  ",
    "contentWithBrand": "أدخل العلامة التجارية أو الطراز  ",
    "contentwithIp": "البحث حسب اسم الجهاز أو عنوان IP.  ",
    "btnAdd": "مستخدم جديد  ",
    "btnDelete": "حذف  ",
    "btnDownload": "تنزيل القالب  ",
    "btnImport": "الاستيراد الجماعي  ",
    "btnExport": "تنزيل  ",
    "btnDisable": "تعطيل  ",
    "btnEnable": "تمكين  ",
    "accountType": "الفلترة حسب الدور  ",
    "organizationName": "الفلترة حسب المجموعة  ",
    "content": "بحث  ",
    "systemAccount": "معرف المستخدم  ",
    "idCardNumber": "معرف الموظف  ",
    "customizeAccount": "حساب مخصص  ",
    "userName": "الاسم  ",
    "licenseNum": "رقم الترخيص  ",
    "phone": "الهاتف  ",
    "email": "البريد الإلكتروني  ",
    "role": "الدور  ",
    "status": "الحالة  ",
    "affiliatedOrganization": "المجموعات  ",
    "roleTypeList1": "المستخدم العام  ",
    "roleTypeList2": "طالب  ",
    "roleTypeList3": "أب  ",
    "roleTypeList101": "وكيل المسؤول  ",
    "roleTypeList102": "المسؤول  ",
    "roleTypeList301": "المسؤول الأعلى  ",
    "userStatus1": "نشط  ",
    "userStatus2": "محظور  ",
    "userStatus3": "حذف  ",
    "operate": "الإجراءات  ",
    "dialogName": "الاسم المستعار:  ",
    "dialogUserName": "معرف المستخدم:  ",
    "dialogUserNameDefined": "اسم المستخدم:  ",
    "dialogPassword": "كلمة المرور:  ",
    "dialogID": "معرف الموظف:  ",
    "dialogRole": "الدور:  ",
    "dialogEmail": "البريد الإلكتروني:  ",
    "dialogPhone": "الهاتف:  ",
    "dialogGroup": "المجموعة:  ",
    "addUser": "مستخدم جديد  ",
    "editUser": "تحرير المستخدم  ",
    "addSuccess": "تم الإضافة بنجاح!  ",
    "addError": "فشل في الإضافة!  ",
    "editSuccess": "تم التحرير بنجاح!  ",
    "editError": "فشل في التحرير!  ",
    "delSuccess": "تم الحذف بنجاح!",
    "delError": "فشل الحذف!  ",
    "cancel": "إلغاء  ",
    "confirm": "تأكيد  ",
    "save": "حفظ  ",
    "tableDel": "حذف  ",
    "tableEdit": "تحرير  ",
    "selectRoles": "اختيار الأدوار  ",
    "delTitle": "هل ترغب في الحذف؟  ",
    "delTitleContent": "سيتم حذف المحتويات المحددة من قاعدة البيانات. لا يمكن التراجع عن هذه العملية. هل أنت متأكد أنك تريد المتابعة؟  ",
    "delCancelButton": "إلغاء  ",
    "delConfirmButton": "تأكيد  ",
    "titleRealNameRq": "يجب ملء هذا الحقل  ",
    "titleRealNameFormat": "اختر اسم مستخدم يحتوي فقط على الأحرف والأرقام.  ",
    checkPasswordTitleTwo: 'يرجى تعيين كلمة مرور لا تقل عن 6 أحرف، تحتوي على أحرف وأرقام. يمكن استخدام الرموز الخاصة (بدون قيود).',
    checkPasswordTitle: 'يجب أن تتكون كلمة المرور من 6 أحرف على الأقل ولا يمكن أن تكون أرقامًا فقط',
    "titlePhoneFormat": "الهاتف يجب أن يحتوي فقط على الأرقام و () و + و -.  ",
    "phoneFilled": "يجب ملء الهاتف.  ",
    "titleEmaileFormat": "خطأ في تنسيق البريد الإلكتروني.  ",
    "emaileFilled": "يجب ملء البريد الإلكتروني.  ",
    "titlUserNameDefinedNub": "اسم المستخدم لا يمكن أن يتجاوز 30 حرفًا  ",
    "titlRealNameNub": "الاسم لا يمكن أن يتجاوز 30 حرفًا.  ",
    "titlRealNameField": "يجب ملء الاسم.  ",
    "thisPasswordField": "يجب ملء كلمة المرور.  ",
    "titlPassWordNub": "يجب أن تكون كلمة المرور بين 6 و 30 حرفًا  ",
    "enableStatus": "تمكين المستخدم  ",
    "stopStatus": "تعطيل المستخدم  ",
    "enableContent": "هل أنت متأكد أنك تريد تمكين المستخدم؟  ",
    "stopContent": "هل أنت متأكد أنك تريد تعطيل المستخدم؟  ",
    "error1400": "اسم المستخدم موجود بالفعل، يرجى المحاولة مرة أخرى  ",
    "error1401": "معرف المستخدم موجود بالفعل، العملية فشلت!  ",
    "error1402": "المجموعة غير موجودة، فشل الاستيراد!  ",
    "error1403": "البيانات غير صحيحة  ",
    "error1404": "الصلاحيات غير كافية  ",
    "selUser": "يرجى اختيار مستخدم!  ",
    "error1405": "فشل الحصول على الدور  ",
    "error1406": "تنسيق بيانات المستخدم المستورد غير صحيح  ",
    "error1407": "البريد الإلكتروني موجود بالفعل، العملية فشلت.  ",
    "error1408": "رقم الهاتف موجود بالفعل، العملية فشلت.  ",
    "error1900": "المعلمة المستدعاة فارغة  ",
    "error1610": "يرجى استخدام دور المسؤول الطرفي لإجراء العمليات المتعلقة  ",
    "errorOrgIdList": "المجموعة لا يمكن أن تكون فارغة!  ",
    "Bindsucceeded": "تم الربط بنجاح  ",
    "Bindfailed": "فشل الربط  ",
    "tableuserName": "اسم المستخدم  ",
    "titleDevice": "الجهاز  ",
    "bindDevice": "الجهاز المرتبط  ",
    "Bindcontrollable": "هل ترغب في ربط الجهاز القابل للتحكم الآن؟  "
  },
  "devicesMge": {
    mustChooseOne: 'عند تحديد التحكم عن بعد الذكي، يجب اختيار أمر تحكم واحد على الأقل',
    customName: 'اسم مخصص',
    "testAcCode": "اختبار رمز التحكم الجديد A/C",
    "Online": "متصل",
    "Offline": "غير متصل",
    "unBindConfirm": "تأكيد لفصل ارتباط Serial",
    "unBindConfirm485": "تأكيد لفصل ارتباط RS485",
    "notYetBoundRS232": "الجهاز ليس مرتبطًا بعد برمز Serial. يمكنك الانتقال إلى الجهاز > رمز التحكم Serial لإضافته.",
    "RsFollowingFunctions": "يمكن تنفيذ الوظائف التالية عبر أكواد Serial:",
    "Unbind": "إلغاء الارتباط",
    "Limit255": "اسم الملف يحتوي على أقصى حد من 255 حرفًا",
    "clear": "مسح",
    "equipName": "اسم الجهاز",
    "equipType": "النوع",
    "selectField": "يرجى اختيار ملف",
    "dialogTip": "*إذا كان مربع الإدخال على اليمين فارغًا، يتم عرض المحتوى على اليسار بشكل افتراضي",
    "dialogTipSingle": "*إذا لم يتم تسمية جهاز واحد، استخدم الاسم \"الكل\"",
    "cantDelTemplateOne": "The CBX of ",
    cantDelTemplateTwo: 'إن CBX الخاص بالجهاز "{deviceName}" عبارة عن قالب. هل أنت متأكد من رغبتك في حذفه؟',
    "templateTitle": "استبدال القالب",
    "templateContentOne": "The device name \"",
    "templateContentTwo": "\" has been set as the common CBX template. Are you sure to set the current device as the template?",
    "vcbNoTemplateNoSave": "لا يمكن الحفظ بدون القالب",
    "vcbAcControl": "اختر جهاز A/C",
    "vcbRemoteControl": "اختر جهاز التحكم عن بُعد",
    "vcbPOWERControl": "تحكم بالطاقة",
    "vcbRS232Control": "تحكم Serial",
    "vcbIRControl": "تحكم IR",
    "vcbSetting": "إعدادات CBX",
    "editVcb": "تحرير CBX",
    "vcbName": "اسم CBX",
    "iot": "تحكم CBX",
    "saveAsTemplate": "حفظ كقالب",
    saveAsTemplatereplenish: 'حدد عدة أجهزة لاستخدام هذا القالب في مركز التحكم',
    "Upload": "تحميل",
    "Select": "اختيار",
    "InputDeviceID": "أدخل معرف الجهاز",
    "editNameTips": "* يتم عرض المحتوى على اليسار بشكل افتراضي عندما يكون مربع الإدخال على اليمين فارغًا.",
    "_RS232A": "الواجهة الأولى",
    "_RS232B": "الواجهة الثانية",
    "institutionDirectory": "دليل المؤسسة",
    "projectionScreenLinkageSetting": "إعدادات التحكم في شاشة العرض",
    "screenLiftingLinkageDisplaySwitch": "التحكم في ربط شاشة العرض والشاشة:",
    "stopLinkage": "تعطيل (التحكم في شاشة العرض بشكل منفصل)",
    "Enable": "تمكين (التحكم المتزامن في شاشة العرض والشاشة)",
    "btnAddDevice": "إضافة جهاز",
    "btnImportDevice": "استيراد الأجهزة بالجملة",
    "btnDel": "حذف",
    "btnEdit": "تحرير",
    "tableIpAddress": "عنوان IP",
    "MACAddress": "عنوان MAC",
    "firmwareVersion": "إصدار البرنامج الثابت",
    "NA": "غير متاح",
    "tableDeviceName": "اسم الجهاز",
    "tableStatus": "الحالة",
    "tableVideoSwitch": "مفتاح الفيديو",
    "tableAudio": "توزيع A/V",
    "tablePowerControl": "تحكم بالطاقة",
    "tableRS232": "التحكم التسلسلي",
    "tableIR": "التحكم IR",
    "tableRFIDCard": "بطاقة IC",
    "tableControlPanel": "لوحة التحكم",
    "tableOrganization": "المجموعات",
    "tableActions": "الإجراءات",
    "dialogAddTitle": "إضافة جهاز",
    "dialogEditTitle": "تحرير جهاز",
    "dialogBatchAddTitle": "إضافة أجهزة بالجملة",
    "dialogBatchEditTitle": "تحرير أجهزة بالجملة",
    "btnCancel": "إلغاء",
    "Devices": "الأجهزة:",
    "ProjectorCode": "رمز Serial:",
    "Group": "المجموعة:",
    "btnBatchAdd": "إضافة بالجملة",
    "delTitle": "حذف؟",
    "delTitleContent": "سيتم حذف المكونات المحددة من قاعدة البيانات. هذه العملية غير قابلة للتراجع. هل أنت متأكد من أنك تريد المتابعة؟",
    "delCancelButton": "إلغاء",
    "delConfirmButton": "تأكيد",
    "addError": "فشل في الإضافة!",
    "editSuccess": "تم التعديل بنجاح!",
    "editError": "فشل في التعديل!",
    "delSuccess": "تم الحذف بنجاح!",
    "delError": "فشل في الحذف!",
    "content": "بحث",
    "cancel": "إلغاء",
    "confirm": "تأكيد",
    "save": "حفظ",
    "tableDel": "حذف",
    "tableEdit": "تحرير",
    "selectRoles": "اختيار الأدوار",
    "selectType": "يرجى اختيار نوع",
    "selectDevices": "يرجى اختيار جهاز",
    "titleRealNameRq": "يجب ملء هذا الحقل",
    "titleRealNameNub": "أقل من 100 حرف",
    "titlPassWordNub": "أقل من 15 حرف",
    "error1900": "المعلمة المسترجعة فارغة",
    "error2000": "تجاوز العدد الأقصى للأجهزة القابلة للاتصال",
    "error2001": "رمز الجهاز المستورد غير صحيح أو لم يتم إدخاله في النظام بعد.",
    "error2002": "تم استيراد اسم جهاز مكرر",
    "error2003": "تم استخدام معرف الجهاز المستورد بالفعل",
    "error2004": "خطأ في البيانات المستوردة",
    "error2005": "اسم العلامة التجارية أو الموديل يتكر مع البيانات الموجودة في النظام؛ يرجى إعادة تسمية العلامة التجارية أو الموديل.",
    "error2008": "تم ربط هذا الجهاز بالفعل مع مجموعة أخرى",
    "notDevicesName": "اسم الجهاز لا يمكن أن يكون فارغًا",
    "notDevicesNO": "معرف الجهاز لا يمكن أن يكون فارغًا",
    "dialogDevicesName": "اسم الجهاز:",
    "dialogDevicesID": "معرف الجهاز:",
    "dialogProjectorCode": "رمز Serial:",
    "dialogGroup": "المجموعة:",
    "dialogSel": "يرجى الاختيار",
    "errorOrgIdList": "لا يمكن أن تكون المجموعة فارغة!",
    "errorDevicesName": "لا يمكن أن يكون اسم الجهاز فارغًا!",
    "errorDevicesNo": "لا يمكن أن يكون معرف الجهاز فارغًا!",
    "dialogTiltleDevices": "الأجهزة:",
    "uploadSuccess": "تم التحميل بنجاح",
    "addSuccess": "تم الإضافة بنجاح",
    "ChooseGroups": "اختيار المجموعات",
    "ChooseIcon": "اختيار الرمز",
    "dialogDevicesTitle": "تم تطبيق إعدادات المعلمات على الأجهزة التالية",
    "backDevice": "الرجوع",
    "bootSetting": "خيارات بدء التشغيل",
    "nmpOpenSetting": "إعدادات التشغيل",
    "npsOpenSetting": "إعدادات التشغيل",
    "nmpPowerSettings": "إعدادات الطاقة",
    "npsPowerSettings": "إعدادات الطاقة",
    "nmpInterfaceSettings": "إعدادات الواجهة",
    "npsInterfaceSettings": "إعدادات الواجهة",
    "nmpDefaultChannel": "إعدادات القناة الافتراضية",
    "nmpCloseSetting": "إعدادات الإيقاف",
    "npsCloseSetting": "إعدادات الإيقاف",
    "SwipeToStart": "تمكين القفل (اضغط على البطاقة لإلغاء القفل)",
    "ControlPanelToStart": "تعطيل القفل (عملية غير محدودة)",
    "Display": "العرض",
    "External": "خارجي",
    "startingUpMethod": "تمكين/تعطيل قفل اللوحة:",
    "startWith": "ابدأ بـ:",
    "nmpstartWith": "تشغيل متزامن:",
    "nmpcloseWith": "إيقاف متزامن:",
    "RS232Tip": "عند إيقاف تشغيل الطاقة الرئيسية، ستتلقى إجمالي 5 واجهات Serial، بما في ذلك Serial وحتى 4 CBX، شفرة أمر الإيقاف المناسبة.",

    startPowerTip: 'عند التشغيل، يتم تشغيل جميع الأجهزة المتصلة بواجهات الطاقة في CBX.',
    startAirTip: 'عند التشغيل، يتم تشغيل جميع أجهزة التكييف المرتبطة عبر الأشعة تحت الحمراء من الجهاز/CBX.',
    startIrTip: 'عند التشغيل، يتم إرسال أمر تحكم عبر الأشعة تحت الحمراء من الجهاز/CBX (مثل إنزال الستارة، تشغيل جهاز العرض).',
    startRSTip: 'عند التشغيل، يتم إرسال أمر تشغيل عبر منفذ Serial من الجهاز/CBX.',
    CloseDisplayTip: 'يتم إيقاف تشغيل الأجهزة المتصلة بمنفذ DISPLAY تلقائيًا عند إيقاف تشغيل NDP/NMP. يتم التحكم في هذا الإعداد من خلال البرنامج الثابت ولا يمكن تغييره من خلال البرنامج.',
    CloseExternalTip: 'يتم إيقاف تشغيل الأجهزة المتصلة بمنفذ EXTERNAL تلقائيًا عند إيقاف تشغيل NDP/NMP. يتم التحكم في هذا الإعداد من خلال البرنامج الثابت ولا يمكن تغييره من خلال البرنامج.',
    ClosePowerTip: 'عند الإيقاف، يتم إيقاف تشغيل جميع الأجهزة المتصلة بواجهات الطاقة في CBX.',
    CloseAirTip: 'عند الإيقاف، يتم إيقاف جميع أجهزة التكييف المرتبطة عبر الأشعة تحت الحمراء من الجهاز/CBX.',
    CloseIrTip: 'عند الإيقاف، يتم إرسال أمر تحكم عبر الأشعة تحت الحمراء من الجهاز/CBX (مثل رفع الستارة، إيقاف تشغيل جهاز العرض).',
    CloseRSTip: 'عند الإيقاف، يتم إرسال أمر إيقاف عبر منفذ Serial من الجهاز/CBX.',
    npsOpenRS232Tip: 'عند تشغيل مصدر الطاقة الرئيسي، سيتلقى واجهتي المنفذ التسلسلي لـ NPS رموز أوامر التشغيل المقابلة.',
    "npsRS232Tip": "عند إيقاف تشغيل الطاقة الرئيسية، ستتلقى واجهتي Serial في NPS شفرة أمر الإيقاف المناسبة.",
    "useCardTip": "بعد فك قفل البطاقة، سيتم تفعيل طاقة الأجهزة تلقائيًا.",
    "npsCardTip": "بعد فك قفل البطاقة، سيتم تفعيل الطاقة الرئيسية للأجهزة تلقائيًا.",
    "PowerOutageHandling": "إدارة انقطاع الطاقة",
    "PowerOutageHandTip": "للاستمرار في الوصول أثناء انقطاع الطاقة غير المتوقع، اختر \"فك القفل في حالة انقطاع الطاقة\". وإلا، حدد \"قفل في حالة انقطاع الطاقة\" لتقييد الوصول.",
    "acSetting": "إعدادات A/C",
    "ChooseType": "نوع الجهاز",
    "ChooseBrand": "اختر علامة تجارية",
    "ChooseModel": "اختر نموذجًا",
    "btnConnectingTest": "اختبار الاتصال",
    "LockSetting": "إعداد القفل الكهربائي",
    "ElectricLockType": "نوع القفل الكهربائي:",
    "PowerUNLOCK": "فتح القفل في حالة انقطاع الطاقة",
    "PowerLOCK": "قفل في حالة انقطاع الطاقة",
    "none": "لا شيء",
    "oddParity": "الزوجي المتقطع",
    "EvenParity": "الزوجي الكامل",
    "LastSetting": "الإعداد الأخير",
    "ElectricLockClosing": "إغلاق القفل الكهربائي:",
    "manualSwitch": "مفتاح يدوي",
    "Auto": "تلقائي (في",
    "projectorSetting": "اختيار الجهاز وربطه",
    "baudRate": "معدل الباود",
    "Parity": "التماثل",
    "ON": "تشغيل",
    "OFF": "إيقاف",
    "Channel1": "القناة 1",
    "Channel2": "القناة 2",
    "PowerOffDelay": "تأخير إيقاف التشغيل",
    "second": "ث",
    "DefaultChannel": "القناة الافتراضية",
    "HDMIA": "HDMI الخروج A:",
    "HDMIB": "HDMI الخروج B:",
    "HDMIC": "HDMI الخروج C:",
    "btnSaveApply": "حفظ وتطبيق على...",
    "btnSave": "حفظ",
    "btnCustomize": "مخصص",
    "ACIsPowerTitle": "التحقق مما إذا كان التكييف يعمل؟",
    "ACIsPowerContent": "يرجى إيقاف التكييف قبل الاختبار. إذا لم يتم تشغيله بنجاح، يرجى التأكد من أن ماركة وطراز التكييف صحيحة.",
    "btnNextModel": "لا، اختبر النموذج التالي",
    "btnYes": "نعم",
    "errorConnecting": "فشل اختبار الاتصال",
    "hot": "حار",
    "_MAGNETICLOCK": "القفل الإلكتروني",
    "_AIR": "مكيف الهواء",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    '_AUDIOA': 'HDMI out A',
    '_AUDIOB': 'Audio IN 1',
    '_AUDIOC': 'Audio IN 2',
    "_USB1": "USB 1",
    "_USB2": "USB 2",
    "_USB3": "USB 3",
    "_USBA": "USB A",
    "_USBB": "USB B",
    "IRControl": "إعدادات التحكم IR",
    "acControlTitle": "اختيار جهاز A/C:",
    "acControlTitleNew": "جهاز A/C",
    "intelligentControlTitle": "اختيار جهاز التحكم عن بعد:",
    "intelligentControlTitleNew": "جهاز التحكم عن بعد",
    "btnACControlCode": "التعرف على رمز التحكم A/C الجديد",
    "btnAddRemoteControl": "رمز التحكم عن بعد الجديد",
    "ACControlCodeTitle": "التعرف على رمز التحكم A/C",
    "ACControlCodeseft1": "التعرف على الرمز",
    "ACControlCodeseft2": "إضافة معلومات",
    "btnStartIdentify": "بدء",
    "Identifysuccess": "تم التعرف بنجاح!",
    "BeingIdentify": "جار التحليل...",
    "acBrand": "ماركة التكييف",
    "acModel": "موديل التكييف",
    "IdentifyFailureTitle": "فشل في العثور على الرمز",
    "IdentifyFailureContent": "فشلت عملية التعرف، هذا النموذج غير مدعوم حالياً. يرجى محاولة استخدام جهاز التحكم عن بعد",
    "btnTryAgain": "إعادة المحاولة",
    "btnJump": "الذهاب إلى جهاز التحكم عن بعد",
    "ACrideo": "A/C",
    "ortherRideo": "أجهزة أخرى",
    "btnBack": "عودة",
    "btnSortOut": "الذهاب إلى التحرير",
    "remoteControlSeft1": "اختيار نوع الجهاز",
    "remoteControlSeft2": "تعلم الرمز",
    "remoteControlSeft3": "إضافة معلومات",
    "addRemoteControlError": "آسف، لا يمكن تعلم المزيد من الرموز. يرجى تعديل الرموز الحالية لجهاز التحكم عن بعد أولاً",
    "btnPrevious": "السابق",
    "btnNextStep": "التالي",
    "remoteControlErrorTitle": "فشل تعلم الرمز",
    "remoteControlErrorContent1": "1. جهاز الإرسال بالأشعة تحت الحمراء غير محجوب",
    "remoteControlErrorContent2": "2. لا يوجد تداخل ضوء قوي حول المستقبل",
    "remoteControlErrorContent3": "3. جهاز الإرسال بالأشعة تحت الحمراء مثبت بشكل صحيح",
    "remoteControlErrorContent4": "4. جهاز التحكم عن بعد يعمل بشكل جيد",
    "deviceItem1": "A/C",
    "deviceItem2": "جهاز عرض",
    "deviceItem3": "تلفزيون",
    "deviceItem4": "مروحة",
    "deviceItem5": "إضاءة",
    "deviceItem6": "أخرى",
    "deviceItem7": "لوحة تفاعلية",
    "deviceItem8": "نظام تسجيل المحاضرات",
    "deviceItem9": "كاميرا PTZ",
    "RS232protocol": "بروتوكول Serial:",
    "btnRemoteControl": "بدء التعلم",
    "BeingIdentify1": "جار التحليل...",
    "Identifysuccess1": "نجاح",
    "controllerType1": "A/C",
    "controllerType2": "Serial",
    "controllerType3": "تلفزيون",
    "controllerType4": "مروحة",
    "controllerType5": "إضاءة",
    "controllerType9": "أخرى",
    "rqRemoteControlCode": "يرجى إدخال اسم رمز جهاز التحكم عن بعد",
    "rqBrand": "يرجى إدخال ماركة A/C",
    "rqModel": "يرجى إدخال طراز A/C",
    "error2016": "اسم جهاز التحكم عن بعد مكرر، يرجى إدخال اسم آخر",
    "RS232Setting": "إعداد رمز السيريال",
    "IR232Setting": "إعداد IR",
    "SystemError": "خطأ في النظام. يرجى المحاولة مرة أخرى",
    "conditionerCodeContent": "لم يتم العثور على رمز مكيف الهواء، يرجى المحاولة مرة أخرى",
    "remoteControlCodeContent": "لم يتم العثور على رمز جهاز التحكم عن بعد، يرجى المحاولة مرة أخرى",
    "btnRetry": "إعادة المحاولة",
    "Bindusers": "ربط المستخدم",
    "tablebinduser": "ربط المستخدمين",
    "Refresh": "تحديث",
    "Binduserlable": "ربط المستخدمين الذين يمكنهم التحكم في الجهاز الآن؟",
    "SaveApplySuccessfully": "حفظ وتطبيق بنجاح",
    "DeviceType": "النوع:",
    "tableDeviceType": "النوع",
    "empty": "فارغ.",
    "sendCommand": "إرسال لاحقًا",
    "enable": "تمكين",
    "disable": "تعطيل",
    "SYNCremoteControl": "مزامنة مع جهاز التحكم عن بعد",
    "analysisfailed": "فشل التحليل، يرجى المحاولة مرة أخرى",

    "CBX": {
      "powerSupplyON": "تشغيل",
      "powerSupplyOFF": "إيقاف تشغيل",
      "powerVcrON": "بدء التسجيل",
      "powerVcrOFF": "إيقاف التسجيل",
      "lockScreenON": "قفل التشغيل",
      "lockScreenOFF": "قفل الإيقاف",
      "childLockON": "تفعيل القفل للأطفال",
      "childLockOFF": "إيقاف القفل للأطفال",
      "energySavingON": "تفعيل توفير الطاقة",
      "energySaving": "توفير الطاقة",
      "energySavingOFF": "إيقاف توفير الطاقة",
      "signalSourceSwitchingON": "OPS",
      "signalSourceSwitchingOFF": "Android",
      "volumeAdjustment": "مكبر الصوت",
      "brightAdjustment": "السطوع",
      "other": "الميزات الأخرى...",
      "volumeExample": "وظيفة Serial كاملة مطلوبة للتوافق الكامل مع نظام التسجيل.",
      "functionCode": "الوظيفة:",
      "Name": "الاسم:",
      "controlCode": "كود التحكم:",
      "brand": "العلامة التجارية:",
      "model": "النموذج:",
      "errorBrandName": "لا يمكن أن تكون العلامة التجارية فارغة!",
      "errorModelName": "لا يمكن أن يكون النموذج فارغاً!"
    }

  },
  "roleMge": {
    "role1": "مستخدم عام",
    "role101": "مسؤول وكيل",
    "role102": "مسؤول",
    "role4": "دور مخصص",
    "roleNew": "دور جديد",
    "btnAddRole": "إضافة دور",
    "chooseUser": "اختر المستخدم",
    "titleLevel": "مستوى خاصية البث:",
    "titleSettings": "إعدادات الأذونات:",
    "btnSave": "حفظ",
    "btnDelete": "حذف",
    "cancel": "إلغاء",
    "confirm": "تأكيد",
    "save": "حفظ",
    "addSuccess": "تم الإضافة بنجاح!",
    "addError": "فشل في الإضافة!",
    "editSuccess": "تم التعديل بنجاح!",
    "editError": "فشل في التعديل!",
    "delSuccess": "تم الحذف بنجاح!",
    "delError": "فشل في الحذف!",
    "V3_0_OrganizationManage": "إدارة المجموعات",
    "V3_0_UserManage": "إدارة المستخدمين",
    "V3_0_DeviceManage": "إدارة الأجهزة",
    "V3_0_CloudSpaceManage": "إدارة المساحة السحابية",
    "V3_0_OrganizationManage_View": "عرض",
    "V3_0_OrganizationManage_Edit": "تعديل",
    "V3_0_UserManage_View": "عرض",
    "V3_0_UserManage_Edit": "تعديل",
    "V3_0_DeviceManage_AddDevice": "إضافة جهاز",
    "V3_0_DeviceManage_Operating": "تشغيل",
    "V3_0_DeviceManage_Delete": "حذف",
    "V3_0_DeviceManage_Edit": "تعديل",
    "V3_0_CloudSpaceManage_PersonalManage": "إدارة السحابة الشخصية",
    "V3_0_CloudSpaceManage_PublicManage": "إدارة السحابة العامة",
    "V3_0_CloudSpaceManage_SpaceManage": "تخصيص المساحة",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "التشغيل",
    "V3_0_CloudSpaceManage_PersonalManage_View": "عرض",
    "V3_0_CloudSpaceManage_PublicManage_View": "عرض",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "رفع",
    "V3_0_CloudSpaceManage_PublicManage_Download": "تحميل",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "حذف الملف",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "تحرير المجلد",
    "delTitle": "هل تريد الحذف؟",
    "delTitleContent": "سيتم حذف المحتويات المحددة من قاعدة البيانات. هذه العملية لا يمكن التراجع عنها. هل أنت متأكد أنك تريد المتابعة؟",
    "delCancelButton": "إلغاء",
    "delConfirmButton": "تأكيد",
    "btnAdd": "إضافة دور",
    "RoleName": "اسم الدور:",
    "ManageRange": "نطاق الإدارة:",
    "ChooseUser": "اختيار المستخدم:",
    "PermissionSettings": "إعدادات الأذونات:",
    "BroadcastingPropertyLevel": "مستوى خاصية البث",
    "ChooseGroups": "اختيار المجموعات",
    "ChooseTheUser": "اختيار المستخدم",
    "deleleTitle": "الدور الجديد لم يتم حفظه. إذا غادرت، سيتم حذف الدور. هل أنت متأكد أنك تريد المغادرة؟",
    "Error1601": "لا يمكن استخدام المسؤول",
    "Error1602": "فشل في الحصول على دور الأذونات",
    "Error1603": "فقط المسؤولين يمكنهم الوصول إلى هذه الوظائف",
    "Error1604": "اسم الدور لا يمكن أن يكون فارغاً",
    "Error1605": "المجموعة لا يمكن أن تكون فارغة",
    "Error1606": "هذا الدور موجود بالفعل",
    "Error1607": "دور معرف من النظام، لا يمكن تعديله",
    "Error1608": "فشل في تعيين الدور",
    "Error1609": "دور المستخدم المشترك للنظام، لا يمكن تعديله",
    "Error1610": "يرجى استخدام دور مسؤول الجهاز لتنفيذ العمليات ذات الصلة",
    "Error1611": "لا يملك الأذونات المتعلقة بالدور"
  },
  "projectorDevicesMge": {
    "tipOne": "1. املأ اسم الوظيفة ورمز التحكم. تستخدم أمثلة رمز التحكم تنسيق HEX.",
    "tipTwo": "2. هذه الواجهة مخصصة فقط لتكوين أوامر التسلسل للتشغيل والإيقاف. يرجى الانتقال إلى 'إدارة الأجهزة / الأجهزة / العمليات / إعدادات الطاقة' لتمكين الوظيفة.",
    "tipFunctionOne": "1. حدد الوظائف الشائعة من القائمة المنسدلة. ستظهر الأيقونات المقابلة على واجهة التحكم التسلسلي للوحة الذكية.",
    "tipFunctionTwo": "2. تُستخدم أوامر 'POWER ON' و'POWER OFF' للربط التسلسلي للتشغيل والإيقاف الخاص بالجهاز. تقوم هذه الصفحة بتكوين رموز التحكم فقط. يرجى الانتقال إلى 'إدارة الأجهزة / الأجهزة / العمليات / إعدادات الطاقة' لتمكين وظيفة الربط.",
    "ListRS232functions": "قائمة وظائف التحكم التسلسلي",
    "Customizefunctionlist": "تخصيص قائمة الوظائف",
    "btnAddProjectorCode": "إضافة رمز تسلسلي",
    "btnDel": "حذف",
    "inputSeach": "بحث",
    "btnEdit": "تعديل",
    "cancel": "تنظيف",
    "confirm": "تأكيد",
    "tableName": "اسم الرمز",
    "tablersType": "نوع الجهاز:",
    "tablersTypeTable": "نوع الجهاز",
    "tableModel": "نموذج",
    "tableBrand": "علامة تجارية",
    "tableActions": "الإجراءات",
    "dialogAddTitle": "إضافة رمز Serial",
    "dialogEditTitle": "تعديل رمز Serial",
    "brand": "اسم العلامة التجارية:",
    "model": "نموذج:",
    "baudRate": "معدل البود:",
    "parity": "التوازي:",
    "powerOn": "تشغيل",
    "powerOff": "إيقاف",
    "pgrInput1": "القناة 1",
    "pgbInput2": "القناة 2",
    "delTitle": "هل تريد الحذف؟",
    "delTitleContent": "سيتم حذف المحتويات المحددة من قاعدة البيانات. هذه العملية لا يمكن التراجع عنها. هل أنت متأكد أنك تريد المتابعة؟",
    "delCancelButton": "إلغاء",
    "delConfirmButton": "تأكيد",
    "content": "بحث",
    "operate": "الإجراءات",
    "tableDel": "حذف",
    "tableEdit": "تعديل",
    "addSuccess": "تمت الإضافة بنجاح!",
    "addError": "فشل في الإضافة!",
    "editSuccess": "تم التعديل بنجاح!",
    "editError": "فشل في التعديل!",
    "delSuccess": "تم الحذف بنجاح!",
    "delError": "فشل في الحذف!",
    "selectTitle": "يرجى اختيار Serial!",
    "selectCode": "اختيار Serial",
    "none": "لا شيء",
    "oddParity": "التوازي الفردي",
    "EvenParity": "التوازي الزوجي"
  },
  "authorityMge": {
    "V3_0_OrganizationManage": "إدارة المجموعات",
    "V3_0_UserManage": "إدارة المستخدمين",
    "V3_0_DeviceManage": "إدارة الأجهزة",
    "V3_0_CloudSpaceManage": "إدارة مساحة السحابة",
    "V3_0_OrganizationManage_View": "عرض",
    "V3_0_OrganizationManage_Edit": "تحرير",
    "V3_0_UserManage_View": "عرض",
    "V3_0_UserManage_Edit": "تحرير",
    "V3_0_DeviceManage_AddDevice": "إضافة جهاز",
    "V3_0_DeviceManage_Operating": "تشغيل",
    "V3_0_DeviceManage_Delete": "حذف",
    "V3_0_DeviceManage_Edit": "تحرير",
    "V3_0_DeviceManage_RepairLog": "سجل الإصلاحات",
    "V3_0_CloudSpaceManage_PersonalManage": "إدارة السحابة الشخصية",
    "V3_0_CloudSpaceManage_PublicManage": "إدارة السحابة العامة",
    "V3_0_CloudSpaceManage_SpaceManage": "إدارة مساحة السحابة",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "تشغيل",
    "V3_0_CloudSpaceManage_PersonalManage_View": "عرض",
    "V3_0_CloudSpaceManage_PublicManage_View": "عرض",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "تحميل",
    "V3_0_CloudSpaceManage_PublicManage_Download": "تنزيل",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "حذف",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "تحرير",
    "delTitle": "حذف؟",
    "delTitleContent": "سيتم حذف المكونات المحددة من قاعدة البيانات. لا يمكن التراجع عن هذه العملية. هل أنت متأكد أنك تريد المتابعة؟",
    "delCancelButton": "إلغاء",
    "delConfirmButton": "تأكيد",
    "content": "بحث",
    "operate": "إجراء",
    "tableDel": "حذف",
    "tableEdit": "تحرير",
    "addSuccess": "تمت الإضافة بنجاح!",
    "addError": "فشل في الإضافة!",
    "editSuccess": "تم التعديل بنجاح!",
    "editError": "فشل في التعديل!",
    "delSuccess": "تم الحذف بنجاح!",
    "delError": "فشل في الحذف!",
    "selectTitle": "يرجى اختيار Serial!"
  },
  "workstationMge": {
    "priorChoice": "تفضيلات البث:",
    "SpeedPriority": "أولوية السرعة",
    "SyncPriority": "أولوية مزامنة الإطارات",
    "SpeedPriorityTip": "بعد إرسال تعليمات البث AV، يمكن لأجهزة Q-NEX تنفيذ مهمة التشغيل في وقت تخزين مؤقت أقصر حوالي 3-5 ثوانٍ. يوصى بأولوية السرعة عندما يعمل خادم الوسائط في LAN.",
    "SyncPriorityTip": "بعد إرسال تعليمات البث AV، يمكن لأجهزة Q-NEX تنفيذ مهمة التشغيل بشكل متزامن مع وقت تخزين مؤقت حوالي 8-12 ثانية.",
    "btnAddMedia": "إضافة خادم وسائط",
    "btnBack": "عودة",
    "tableMediaLibId": "معرف خادم الوسائط",
    "tableMediaLibName": "اسم خادم الوسائط",
    "tableState": "حالة الشبكة",
    "tableBindingUsers": "المستخدمين المرتبطين",
    "tableLiveAddress": "عنوان البث",
    "tableAddress": "عنوان البث المباشر",
    "tableOperate": "الإجراءات",
    "tableDel": "حذف",
    "tableEdit": "تعديل",
    "titleMediaStation": "عنوان البث",
    "titleLiveStation": "عنوان البث المباشر:",
    "radioPublic": "عام",
    "radioPrivate": "خاص",
    "btnSave": "حفظ",
    "titleUsers": "المستخدمين",
    "titleCanBe": "يمكن ربطهم",
    "titleHaveBeen": "تم ربطهم بالفعل",
    "titleMore": "هل تحتاج إلى إضافة المزيد؟",
    "btnAdd": "إضافة",
    "content": "بحث",
    "tableName": "الاسم",
    "tableUserName": "اسم المستخدم",
    "operate": "الإجراءات",
    "affiliatedOrganization": "المجموعات",
    "dialogTitle": "إضافة خادم وسائط جديد",
    "dialogTitleEdit": "تحرير خادم الوسائط الجديد",
    "dialogItemName": "الاسم:",
    "dialogItemId": "ID:",
    "dialogItemIp": "عنوان البث:",
    "titleSelectUsers": "اختيار المستخدمين",
    "selectMedia": "يرجى اختيار الوسائط",
    "delTitle": "هل أنت متأكد من الحذف؟",
    "delMediaLibTitle": "تأكيد الحذف؟",
    "delTitleContent": "سيتم حذف المحتويات المحددة من قاعدة البيانات. لا يمكن التراجع عن هذه العملية. هل أنت متأكد من أنك تريد الاستمرار؟",
    "delTitleMediaLibContent": "سيؤدي إجراء الحذف إلى مسح البيانات ذات الصلة ولا يمكن التراجع عنه.",
    "delCancelButton": "إلغاء",
    "delConfirmButton": "تأكيد",
    "selectDevices": "يرجى اختيار الأجهزة",
    "selectUser": "يرجى اختيار المستخدمين",
    "addUser": "إضافة مستخدم",
    "editUser": "تحرير مستخدم",
    "addSuccess": "تم الإضافة بنجاح!",
    "addError": "فشل في الإضافة!",
    "editSuccess": "تم التعديل بنجاح!",
    "editError": "فشل في التعديل!",
    "delSuccess": "تم الحذف بنجاح!",
    "delError": "فشل في الحذف!",
    "cancel": "إلغاء",
    "confirm": "تأكيد",
    "save": "حفظ",
    "error2500": "تجاوز الحد الأقصى لعدد الأجهزة التي يمكن ربطها بمحطة العمل الحالية.",
    "DeviceName": "اسم الجهاز",
    "AssociatedUserManagement": "إدارة المستخدمين المرتبطين",
    "btnDel": "حذف",
    "errorMsgId": "تعذر العثور على هذا المعرف",
    "LiveStreaming": "عنوان البث:",
    "NoFoundMediaId": "تعذر الحصول على معرف خادم الوسائط",
    "AlreadyConnectedOrg": "خادم الوسائط مرتبط بالفعل بمنظمة أخرى",
    "AlreadyBoundMedia": "لقد قامت هذه المنظمة بالفعل بربط خادم الوسائط ولا يمكنها ربط المزيد",
    "DeleteSecondaryConfirmation": "لا يمكن استرداد البيانات بعد حذف خادم الوسائط، يرجى التأكيد مرة أخرى."
  },
  "cloudDiskMge": {
    "totalStorage": "إجمالي التخزين",
    "GetMore": "احصل على المزيد",
    "StorageSpace": "مساحة التخزين",
    "Adjustment": "تعديل",
    "moreSpace": "احصل على المزيد من مساحة التخزين",
    "PublicStorage": "التخزين العام",
    "PublicStorageUsed": "التخزين العام المستخدم",
    "PublicStorageLasted": "التخزين العام المتبقي",
    "IndividualStorageUsed": "التخزين الشخصي المستخدم",
    "IndividualStorageLasted": "التخزين الشخصي المتبقي",
    "storageSpace": "تعديل مساحة التخزين",
    "tableUserName": "اسم المستخدم",
    "tableUsedSpace": "المساحة المستخدمة",
    "tableAvailableSpace": "المساحة المتاحة",
    "tableActiveTime": "آخر وقت نشط",
    "tableOperate": "الإجراءات",
    "cleanup": "ملاحظة للتنظيف",
    "IndividualStorageSpaceAdjustment": "تعديل مساحة التخزين الشخصية",
    "titleTotal": "الإجمالي",
    "PublicDisk": "السحابة العامة",
    "IndividualDisk": "السحابة الشخصية",
    "PerUser": "لكل مستخدم",
    "UsersInTotal": "إجمالي المستخدمين",
    "cancel": "إلغاء",
    "confirm": "تأكيد",
    "save": "حفظ",
    "addSuccess": "تم الإضافة بنجاح!",
    "addError": "فشل في الإضافة!",
    "editSuccess": "تم التعديل بنجاح!",
    "editError": "فشل في التعديل!",
    "delSuccess": "تم الحذف بنجاح!",
    "delError": "فشل في الحذف!",
    "error3000": "فشلت العملية لأن الحجم الإجمالي للتخزين تم تجاوزه.",
    "error3003": "فشلت العملية، يرجى التحقق مما إذا تم إعداد خادم الوسائط.",
    "IndividualStorage": "التخزين الشخصي",
    "NoteToCleanup": "ملاحظة للتنظيف",
    "updatePersonalSuccess": "مساحة التخزين السحابية الخاصة بك ستصبح ممتلئة، يرجى تنظيفها في الوقت المناسب",
    "updatePersonalSuccess1": "تم التعديل والحفظ بنجاح",
    "storageUsage": "استخدام التخزين الشخصي",
    "bindIndividualstorage": "المستخدمون المسموح لهم بتخزين سحابي شخصي",
    "UserIndividualstorage": "المستخدمون الذين قاموا بإعداد تخزين سحابي شخصي",
    "Notificationsuccessfully": "تم إرسال الإشعار بنجاح",
    "Notificationfailed": "فشل في إرسال الإشعار",
    "tableName": "الاسم",
    "userID": "معرف المستخدم"
  },
  "dashboard": {
    "exportPdf": "تصدير PDF",
    "or": "-",
    "warrantyCompletionRate": "معدل الإصلاح",
    "frequencyOfEachModule": "نسبة الإصلاح لكل وحدة وظيفية",
    "repairHandling": "حالة معالجة الإصلاح",
    "sourceSwitchInput": "مفتاح الإدخال",
    "micVol": "حجم الميكروفون",
    "volumeSpeaker": "حجم السماعة",
    "airAonditioner": "التكييف",
    "Curtain": "شاشة العرض",
    "remoteControlIntelligent": "التحكم عن بعد",
    "RS232Control": "التحكم Serial",
    "lockElectronic": "الأقفال الإلكترونية",
    "Repairreportcompleted": "تم الإصلاح",
    "Totalnumberofrepairsreported": "إجمالي الإصلاحات",
    "Warrantycompletionrate": "معدل اكتمال الإصلاح",
    "startDate": "تاريخ البدء",
    "endDate": "تاريخ الانتهاء",
    "year": "السنة",
    "month": "الشهر",
    "dayTian": "اليوم",
    "placeholderDate": "اختيار التاريخ",
    "placeholderDateTime": "اختيار الوقت",
    "devicesNub": "الأجهزة",
    "userNub": "المستخدمون",
    "powerNub": "الطاقة (KW/H)",
    "storageUsed": "التخزين المستخدم (%)",
    "userLoginDevice": "فترة زمنية نشطة لتسجيل الدخول للمستخدم",
    "devicePowerConsumption": "استهلاك الكهرباء اليومي لجميع الأجهزة",
    "externalDeviceUsageTime": "استخدام الأجهزة الخارجية",
    "equipmentRunningTime": "استخدام الأجهزة الطرفية",
    "cloudStorageSpace": "استخدام التخزين",
    "powerConsumptionPort": "استهلاك الطاقة لكل منفذ طاقة",
    "mostPopularFile": "أكثر الملفات شعبية",
    "commonFunctions": "الوظائف الشائعة",
    "commonlyUsed": "أكثر طرق البث شيوعاً",
    "fileName": "اسم الملف",
    "usageCount": "عدد الاستخدامات",
    "electricityConsumption": "استهلاك الكهرباء",
    "publicStorageUsed": "التخزين العام المستخدم",
    "publicStorageLasted": "التخزين العام المتبقي",
    "individualStorageUsed": "التخزين الفردي المستخدم",
    "individualStorageLasted": "التخزين الفردي المتبقي",
    "notification": "إشعار",
    "audioBroadcast": "البث الصوتي",
    "videoBroadcast": "البث المرئي",
    "ac": "التكييف",
    "hDMISwitch": "مفتاح HDMI",
    "powerControl": "التحكم في الطاقة",
    "powercontrol": "التحكم في الطاقة",
    "Lock": "قفل",
    "volumeAdjust": "تعديل الصوت",
    "projectionScreen": "شاشة العرض",
    "today": "اليوم",
    "yesterday": "أمس",
    "thisWeek": "هذا الأسبوع",
    "lastWeek": "الأسبوع الماضي",
    "lastMonth": "الشهر الماضي",
    "thisMonth": "هذا الشهر",
    "times": "مرات",
    "usage": "عدد الاستخدامات",
    "eachrTitle": "دقائق",
    "total": "المجموع",
    "NMPSystemissue": "مشكلة نظام NMP",
    "displayPower": "مشكلة الجهاز الخارجي NMP",
    "externalPower": "مشكلة نظام MBX",
    "screen": "مشكلة الجهاز الخارجي MBX",
    "TotalRepairs": "إجمالي الإصلاحات",
    "Repaired": "تم الإصلاح",
    "Unrepaired": "لم يتم الإصلاح",
    "day": "اليوم",
    "Minutes": "دقائق",
    "powerConsumption": "دقائق",
    "Date": "التاريخ",
    "kw": "KW",
    "month1": "الاثنين",
    "month2": "الثلاثاء",
    "month3": "الأربعاء",
    "month4": "الخميس",
    "month5": "الجمعة",
    "month6": "السبت",
    "month7": "الأحد",
    "enmonth1": "يناير",
    "enmonth2": "فبراير",
    "enmonth3": "مارس",
    "enmonth4": "أبريل",
    "enmonth5": "مايو",
    "enmonth6": "يونيو",
    "enmonth7": "يوليو",
    "enmonth8": "أغسطس",
    "enmonth9": "سبتمبر",
    "enmonth10": "أكتوبر",
    "enmonth11": "نوفمبر",
    "enmonth12": "ديسمبر",
    "noData": "لا توجد بيانات"
  },
  "input": {
    "fivedigits": "الرجاء إدخال عدد صحيح موجب مكون من 5 أرقام",
    "titlUserNameField": "يجب ملء اسم المستخدم هذا",
    "thisField": "يجب ملء هذا الحقل",
    "ChooseGroup": "اختر المجموعة",
    "placeholder": "اختر",
    "placeholder_type": "الرجاء اختيار أنواع التحكم في الأجهزة",
    "titlRealNameField": "يجب ملء كلمة المرور",
    "thisPasswordField": "يجب ملء كلمة المرور",
    "titlPassWordNub": "أقل من 15 حرفًا",
    "Post": "أرقام فقط",
    "passwordNoChinese": "لا يمكن ملء هذا المربع بالأحرف الصينية"
  },
  "transfer": {
    "all": "الكل",
    "Choose": "اختر",
    "Selected": "محدد",
    "Subordinate": "تابع"
  },
  "setting": {
    limitPngGif: 'يتم دعم تنسيقات PNG / GIF فقط',
    limit3M: 'يجب ألا يتجاوز حجم الصورة 3 ميجابايت',
    setting_door_Wallpaper_text: 'الحجم الموصى به للصورة: 1280x800، بتنسيق PNG أو GIF',

    "reduction": "استعادة",
    "limitJpg": "صورة الملف الشخصي التي تم تحميلها يمكن أن تكون فقط بتنسيق PNG!",
    "limit2M": "حجم صورة الملف الشخصي التي تم تحميلها لا يمكن أن يتجاوز 2 ميغابايت!",
    "choseFile": "اختيار الملف",
    "textOne": "1. صورة الشعار الموصى بها: الحجم 117 * 40، بتنسيق PNG",
    "textTwo": "2. بعد التحميل، يرجى الانتقال إلى اللوحة اللمسية، والتأكد من أن اللوحة اللمسية متصلة بالإنترنت، ثم انقر على الشعار الأصلي لتحديثه.",
    "customizeLogo": "إعداد الشعار للوحة اللمس",
    "addSuccess": "تمت الإعدادات بنجاح!",
    "settingIp": "إعدادات عنوان IP لتخزين الملفات",
    "ServerIP": "عنوان IP للخادم:",
    "ServerPort": "منفذ الخادم:",
    "btnSave": "حفظ",
    "TimeZoneSetting": "إعداد المنطقة الزمنية",
    "CurrentTime": "الوقت الحالي:",
    "CurrentTimeZone": "المنطقة الزمنية الحالية:",
    "httpsSetting": "تخزين الملفات:",
    "utcName": "الوقت القياسي في غرينيتش UTC/GMT",
    "utc0": "الوقت القياسي في غرينيتش، المملكة المتحدة، لشبونة، تورشافن، لندن، دبلن، إدنبرة",
    "utc0_5": "",
    "utc1": "أوروبا الوسطى، غرب أفريقيا، غرب أفريقيا الوسطى، ألمانيا، أيرلندا، فرنسا، أمستردام، إيطاليا، برلين، روما، إسبانيا، براغ، بلغراد، بروكسل، باريس، مدريد، تونس، الغابون، المغرب",
    "utc1_5": "",
    "utc2": "أوروبا الشرقية، وسط أفريقيا، تركيا، إسرائيل، جنوب أفريقيا، إسطنبول، القاهرة، أثينا، دمشق",
    "utc2_5": "",
    "utc3": "شرق أفريقيا، روسيا، بغداد، الكويت، موسكو، سانت بطرسبرغ",
    "utc3_5": "إيران",
    "utc4": "أبو ظبي، تبليسي، دبي، موريشيوس، بورت لويس",
    "utc4_5": "أفغانستان",
    "utc5": "باكستان، تركمانستان، جزر المالديف، أوزبكستان، أرمينيا، طاجيكستان الهند، مومباي، نيودلهي، بنغالور، كلكتا",
    "utc5_5": "الهند، سريلانكا",
    "utc6": "نوفوسيبيرسك، قيرغيزستان، بنغلاديش، بوتان",
    "utc6_5": "جزر كوكوس أستراليا، فيتنام",
    "utc7": "تايلاند، بانكوك، هانوي، جاكرتا",
    "utc7_5": "",
    "utc8": "الصين، ماليزيا، الفلبين، سنغافورة، تايوان الصين، ماكاو الصين، هونغ كونغ الصين",
    "utc8_5": "",
    "utc9": "اليابان، كوريا الجنوبية، طوكيو، سيول، سابورو، أوساكا، تيمور الشرقية",
    "utc9_5": "الوقت القياسي المركزي الأسترالي",
    "utc10": "أستراليا، فلاديفوستوك، غوام، كانبيرا، ملبورن، سيدني، بابوا غينيا الجديدة",
    "utc10_5": "جزيرة لورد هاو في نيو ساوث ويلز، أستراليا",
    "utc11": "جزر سليمان، جزيرة ساخالين",
    "utc11_5": "جزيرة نورفولك، أستراليا",
    "utc12": "نيوزيلندا، أوكلاند، ويلينغتون، فيجي، نيوزيلندا، ناورو",
    "utc12_5": "",
    "utc13": "كابو فيردي، الأزور",
    "utc13_5": "",
    "utc14": "جورجيا الجنوبية، فرناندو دي نورونها",
    "utc14_5": "",
    "utc15": "البرازيل، سانتياغو، السلفادور، برازيليا، الأوروغواي، الأرجنتين، سورينام",
    "utc15_5": "الوقت القياسي في نيوفاوندلاند",
    "utc16": "فنزويلا، بوليفيا، باراغواي، تشيلي",
    "utc16_5": "فنزويلا",
    "utc17": "التوقيت الشرقي (الولايات المتحدة وكندا)، كولومبيا، تورونتو، الإكوادور، بيرو، كوبا، نيويورك، هاميلتون، سان دييغو",
    "utc17_5": "",
    "utc18": "التوقيت المركزي للولايات المتحدة وكندا، مكسيكو سيتي، مونتيري، شيكاغو، هيوستن، نيو أورلينز، ممفيس",
    "utc18_5": "",
    "utc19": "التوقيت الجبلي، أريزونا، مازاتلان، فينيكس، سالت ليك سيتي، دنفر، إدمونتون",
    "utc19_5": "",
    "utc20": "التوقيت الباسيفيكي، لوس أنجلوس، سان فرانسيسكو، فانكوفر، سياتل، لاس فيغاس",
    "utc20_5": "",
    "utc21": "ألاسكا",
    "utc21_5": "بولينيزيا الفرنسية، جزر ماركيساس",
    "utc22": "هاواي",
    "utc22_5": "",
    "utc23": "سماوة، نييوي",
    "utc23_5": "",
    "utc24": ""
  },
  "repairLog": {
    "DeviceName": "اسم الجهاز:",
    "Time": "الوقت:",
    "startDate": "تاريخ البدء",
    "endedDate": "تاريخ الانتهاء",
    "or": "-",
    "Problem": "المشكلة:",
    "btnSearch": "البحث",
    "tableNO": "لا",
    "tableDeviceName": "اسم الجهاز",
    "tableGroup": "المجموعة",
    "tableStatus": "الحالة",
    "tableDeliveredTime": "وقت التسليم",
    "tableSubmitter": "المرسل",
    "tableUpdatingTime": "وقت التحديث",
    "tableProblem": "المشكلة",
    "tableAdmin": "IT-Admin",
    "tableAdminReply": "رد المسؤول",
    "tableAttachment": "مرفق",
    "state0": "تم التسليم",
    "state1": "قيد المعالجة",
    "state2": "تم الانتهاء",
    "Problem100": "الكل",
    "Problem0": "مشكلة النظام",
    "Problem1": "مشكلة الجهاز الخارجي",
    "ProblemType": "",
    "ProblemType0": "التحكم في الطاقة",
    "ProblemType1": "مفتاح HDMI",
    "ProblemType2": "الميكروفون",
    "ProblemType3": "مكبر الصوت",
    "ProblemType4": "جهاز التكييف",
    "ProblemType5": "شاشة العرض",
    "ProblemType6": "القفل الإلكتروني",
    "ProblemType7": "البث الصوتي والفيديو",
    "ProblemType8": "التحكم IR",
    "ProblemType9": "التحكم Serial",
    "dialogDeviceName": "اسم الجهاز",
    "dialogDeviceID": "معرف الجهاز",
    "dialogGroup": "المجموعة",
    "dialogSubmitter": "المرسل",
    "dialogStatus": "اختر الحالة",
    "dialogProblem": "المشكلة",
    "dialogNotes": "الملاحظات",
    "dialogRepairation": "إصلاح",
    "dialogInProcess": "قيد المعالجة",
    "dialogCompleted": "تم الانتهاء",
    "editSuccess": "تم التعديل بنجاح!",
    "editError": "فشل التعديل!",
    "problemRequired": "يرجى اختيار نوع المشكلة",
    "detailRequired": "يرجى وصف المشكلة بالتفصيل",
    "statusRequired": "يرجى اختيار حالة السجل",
    "btnCancel": "إلغاء",
    "DeliveredTime": "وقت التسليم",
    "UpdatingTime": "وقت التحديث",
    "ITAdmin": "IT-Admin",
    "AdminReply": "رد المسؤول",
    "Note": "ملاحظة",
    "Detail": "تفاصيل",
    "controlPanel": "لوحة التحكم",
    "DeviceType": "النوع",
    "dialogDeliveredTime": "وقت التسليم",
    "Submitter": "المرسل"
  },
  "remoteControl": {
    "QuickActionName": "الاسم",
    "DeviceType": "النوع",
    "Description": "الوصف",
    "tableDescription": "الوصف",
    "editRemoteControl": "تحرير رمز جهاز التحكم عن بُعد",
    "QuickActionNameInput": "الاسم",
    "DescriptionInput": "الوصف",
    "save": "حفظ",
    "Brand": "العلامة التجارية",
    "Model": "النموذج",
    "EditACControlCode": "تحرير رمز التحكم في مكيف الهواء",
    "acBrand": "العلامة التجارية للمكيف",
    "acModel": "نموذج المكيف"
  },
  "card": {
    "btnAddCard": "إضافة بطاقة",
    "btnBatchAddCard": "إضافة بطاقات بكميات",
    "tableCard": "رقم البطاقة",
    "tableState": "الحالة",
    "tableUser": "ربط المستخدم",
    "tableID": "اسم المستخدم",
    "tableType": "نوع البطاقة",
    "tableFfective": "تاريخ الانتهاء",
    "dialogCard": "رقم البطاقة :",
    "dialogState": "الحالة :",
    "dialogUser": "ربط المستخدم :",
    "dialogID": "اسم المستخدم :",
    "dialogType": "نوع البطاقة :",
    "dialogFfective": "تاريخ الانتهاء :",
    "dialogRemarks": "ملاحظات :",
    "dialogAddTitle": "إضافة بطاقة",
    "dialogEidtTitle": "تحرير البطاقة",
    "code2201": "صيغة مدة صلاحية البطاقة غير صحيحة",
    "code2202": "تم ربط هذه البطاقة بالفعل",
    "code2203": "تم ربط هذا المستخدم بالفعل",
    "code2204": "هذه البطاقة غير مربوطة",
    "mastCard": "بطاقة رئيسية",
    "regularCard": "بطاقة عامة",
    "permanent": "دائم",
    "coxPermanent": "دائم",
    "coxTime": "فترة محددة",
    "tableDeviceName": "اسم الجهاز",
    "tableDeviceID": "معرف الجهاز",
    "tableOperating": "عملية",
    "tableOperatingTime": "وقت التشغيل",
    "tableCardID": "رقم البطاقة",
    "tableCardType": "نوع البطاقة",
    "tabluserName": "اسم المستخدم",
    "tabluserId": "معرف المستخدم",
    "unlockPanel": "فتح اللوحة",
    "unlock": "فتح الباب",
    "conAll": "الكل",
    "btnEnable": "تمكين",
    "btnDisable": "تعطيل",
    "enableSuccess": "تم التمكين بنجاح",
    "stopSuccess": "تم تعطيله بنجاح",
    "enableError": "فشل في التمكين",
    "stopError": "فشل في التعطيل",
    "batchCard": "رقم البطاقة بكميات :",
    "titlCardField": "لا يمكن أن يكون رقم البطاقة فارغًا",
    "titlCardFieldFormat": "أحرف وأرقام فقط",
    "dialogBachAddTitle": "إضافة بطاقات بكميات",
    "pleaseTryAgain1": "رقم البطاقة خاطئ (NO. :",
    "pleaseTryAgain2": ")، يرجى المحاولة مرة أخرى"
  },
  privacy: {
    PrivacyPolicy: 'Microsoft Organization Binding Privacy Agreement',
    Byusing: 'Dear User,',
    whatinformation: 'Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking “Agree,” you confirm that you have read and accepted all terms of this agreement.',
    EffectiveDate: 'Effective Date: August 4, 2025',
    title1: 'Required Permissions & Collected Data',
    title1Respects1: 'To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:',
    title1Respects2: 'Delegated Permissions',
    Respects2formation: 'These permissions allow Q-NEX to access your Microsoft account data after login and consent:',
    Respects2formation2: 'Calendars.ReadWrite',
    Respects2formation3: 'Permission Name: Full access to user calendars',
    Respects2formation4: 'Description: Allows the app to create, read, update, and delete events in user calendars.',
    Respects2formation5: 'Purpose: Synchronize personal calendar meetings with the Q-NEX system.',
    Respects2formation6: 'offline_access',
    Respects2formation7: 'Permission Name: Maintain access to data you’ve granted',
    Respects2formation8: 'Description: Allows the app to access authorized data even when you’re not actively using it.',
    Respects2formation9: 'Purpose: Ensures meeting information remains synced even when users are offline.',
    Respects2formation10: 'Openid',
    Respects2formation11: 'Permission Name: Sign in as you',
    Respects2formation12: 'Description: Enables login via work/school accounts and allows the app to read basic profile details.',
    Respects2formation13: 'Purpose: Authenticates user identity for security and associates profiles with meeting data.',
    Respects2formation14: 'Place.Read.All',
    Respects2formation15: 'Permission Name: Read all company places',
    Respects2formation16: 'Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.',
    Respects2formation17: 'Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.',

    tp1: 'Application Permissions (Requires Admin Consent)',
    tp2: 'These permissions enable Q-NEX to sync data automatically without manual reauthorization:',
    tp3: 'Calendars.ReadWrite',
    tp4: 'Permission Name: Read and write calendars in all mailboxes',
    tp5: 'Description: Allows the app to create, read, update, and delete calendar events without user sign-in.',
    tp6: 'Purpose: Syncs schedules from all company meeting room resource mailboxes.',
    tp7: 'Directory.Read.All',
    tp8: 'Permission Name: Read directory data',
    tp9: 'Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.',
    tp10: 'Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.',
    tp11: 'User.Read.All',
    tp12: 'Permission Name: Read all users’ full profiles',
    tp13: 'Description: Allows the app to read user profiles without user sign-in.',
    tp14: 'Purpose: Identifies meeting participants.',
    tp15: 'Place.Read.All',
    tp16: 'Permission Name: Read all company places',
    tp17: 'Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.',
    tp18: 'Purpose: Retrieves full meeting room resource lists and syncs availability statuses.',

    title2: 'Purpose of Data Usage',
    title2Respects1: 'Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.',
    title2Respects2: 'Automatically update room availability to prevent scheduling conflicts.',
    title2Respects3: 'Provide a unified meeting management experience.',

    title3: 'Data Storage & Protection',
    title3Respects1: 'All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.',
    title3Respects2: 'Q-NEX does not share calendar data with third parties unless legally required or for system security.',
    title3Respects3: 'For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.',

    title4: 'Your Rights',
    title4Respects1: 'You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.',

    title5: 'Important Notes',
    title5Respects1: 'Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.',
    title5Respects2: 'Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.',

    contactInformation: 'Contact Information',
    contactInformationContent: 'If you have any questions, please contact: info@qnextech.com',

  }
}



// WEBPACK FOOTER //
// ./src/lang/ar.js